import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import {
  deleteReferral,
  deleteUploadedDocument,
  downloadDocument,
  enhancementService,
  fetchDiagnosisListNew,
  fetchDoctorListNew,
  fetchGovtHospitalListNew,
  getAllStarhealthDocumentsData,
  getProcedureAmountNew,
  getStratsDataNew,
  submitApproval,
  submitApprovalCghsNew,
  updateAllDocumentsData,
} from "../../../apis/patientService";
import { errorMessage, successMessage } from "../../../utils/notificationUtils";
import { rejectJfifUpload } from "../../../utils/fileUploadValidation";
import { Form, message } from "antd";
import {
  fetchProcedureNew,
  resetProcedureDropdown,
} from "../../../models/preAuthClaimSlice";
import dayjs from "dayjs";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../models/patientSlice";
import { IDocumentFields } from "../../../interfaces/ICase";
import DocumentDeficiencyModal from "../../../components/patient/DocumentDeficiencyModal";
import PortalSubmissionModal from "../../../components/patient/PreAuth/PortalSubmissionModal";
import ManuallyIdModal from "../../../components/patient/PreAuth/ManuallyIdModal";
import ProcedureConfirmationModal from "../../../components/patient/PreAuth/PreAuthCghs/ProcedureConfirmationModal";
import PortalSubmitModal from "../../../components/patient/PreAuth/PortalSubmitModal";
import { validationPreAuth } from "../../../apis/PreAuthService";
import {
  fetchStepperData,
  getPortalDataCghsNew,
  getVisitStageStates,
} from "../../../models/preAuthSlice";
import PatientDetailsStageDocument from "../../../components/modals/PatientDetailsStageDocument";
import {
  deleteDoctorNew,
  deleteProcedureCghsNew,
  fetchPreAuthToPortalCghsNew,
  getProcedureFromClaimNew,
  saveDraftCghsNew,
  updateDraftCghsNew,
} from "../../../apis/SchemeService/CGHS/cghsService";
import ConfirmSubmissionModalStage from "../../../components/modals/ConfirmSubmissionModalStage";
import FilePreviewModal from "../../../components/patient/PreAuth-query/FilePreviewModal";
import { UploadDocument } from "../../../models/EnhancementSlice";
import Loader from "../../../utils/Spinners";
import ManuallyClaimIdPortal from "../../../components/patient/PreAuth/ManuallyClaimIdPortal";
import MultipleFilesPreviewModal from "../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import ConfirmationImportProcedureModal from "../../../components/modals/ConfirmationImportProcedureModal";
import PreAuthCghsNew from "../../../components/patient/PreAuth/PreAuthCghs/PreAuthCghsNew";
import { GovtBillFetchRequest } from "../../../models/billsSlice";
import { getGovtBillList } from "../../../apis/govtBillingService";
import { ExclamationOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { errorMessageModal } from "../../../utils/modalMessage";

type PreAuthCghsContainerNewProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

export interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentName?: string;
  requestDocument?: boolean;
  responseDocument?: boolean;
}

const modalBaseConfig = {
  centered: true,
  closable: false,
  maskClosable: false,
  width: 460,
  bodyStyle: { padding: "16px 12px 12px" },
  zIndex: 2500,
};

const containerStyle = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  textAlign: "center" as const,
};

const iconWrapperStyle = (color: string) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 52,
  height: 52,
  borderRadius: "50%",
  border: `2px solid ${color}`,
  boxShadow: `0 0 12px ${color}66`,
  marginBottom: 16,
});

const titleStyle = {
  fontWeight: 700,
  fontSize: 18,
  marginBottom: 8,
  textTransform: "uppercase" as const,
};

const contentStyle = {
  fontSize: 16,
  fontWeight: 500,
  color: "#595959",
  marginBottom: 24,
};

const footerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: 12,
};

const okButtonStyle = (color: string) => ({
  minWidth: 100,
  backgroundColor: color,
  borderColor: color,
  color: "#fff",
  fontWeight: 600,
});

const warningMessageModal = (message: string): void => {
  Modal.confirm({
    ...modalBaseConfig,
    icon: null,
    content: (
      <div style={containerStyle}>
        <div style={iconWrapperStyle("#faad14")}>
          <ExclamationOutlined style={{ fontSize: 24, color: "#faad14" }} />
        </div>

        <div style={titleStyle}>WARNING</div>
        <div style={contentStyle}>{message}</div>
      </div>
    ),
    okText: "OK",
    footer: (_, { OkBtn }) => (
      <div style={footerStyle}>
        <OkBtn />
      </div>
    ),
    okButtonProps: {
      style: okButtonStyle("#faad14"),
    },
  });
};

const PreAuthCghsContainerNew: FC<PreAuthCghsContainerNewProps> = ({
  activeKey,
  sseData,
  sseUpdateCount,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients, preAuth, preAuthClaim, hospital, enhancement, auth } =
    useSelector((state: RootState) => state);
  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0])),
  );
  const currentStageDetails = preAuth?.stepperData?.currentVisitStage;
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);
  const [portalSubmission, setPortalSubmission] = useState(false);
  const [manuallyClaimIdPortal, setManuallyClaimIdPortal] =
    useState<boolean>(false);

  const [manualStatusUpdateCount, setManualStatusUpdateCount] =
    useState<number>(0);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [medcoDoctors, setMedcoDoctor] = useState<any>([]);
  const [govtHospitalList, setGovtHospitalList] = useState<any>([]);
  const [diagnosisList, setDiagnosisList] = useState<any>([]);
  const [procedureStrats, setProcedureStrats] = useState({}); //to store strats of procedure
  const [form] = Form.useForm();
  const [isFetchingProcedure, setIsFetchingProcedure] =
    useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [getClaimIdInitiated, setGetClaimIdInitiated] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [open, setOpen] = useState<boolean>(false); //to open modal confirmation of procedures added
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [isSubmittedOnPortal, setIsSubmittedOnPortal] =
    useState<boolean>(false); //open is already submitted on portal
  const [isManuallyEnteredId, setIsManuallyEnteredId] = useState(false); //open enter id manually
  const [submissionModal, setSubmissionModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false); // to check whether submitting api is going or not so that we can show loader acc. to that
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [allDocumentList, setAllDocumentList] = useState<Document[]>([]);

  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);

  const formattedAdmissionType = [
    { label: "PLANNED", value: "PLN" },
    { label: "EMERGENCY", value: "EMG" },
  ]?.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);

  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [diagnosisData, setDiagnosisData] = useState<any>([]);

  const [
    documentRequestResponseDocuments,
    setDocumentRequestResponseDocuments,
  ] = useState<any>();

  const formattedAdmissionTypeOp = [
    { label: "OPD Consultation", value: "OPC" },
    { label: "Diagnostic Testing", value: "DT" },
    { label: "Daycare procedure", value: "DP" },
    { label: "Emergency", value: "EMG" },
  ].map((option) => ({
    value: option.value + "~" + option?.label,
    label: option.label,
  }));

  const formattedPatientDiagnosed = ["MEDCO", "OTHERS"]?.map((option) => ({
    value: option === "OTHERS" ? "Others" : option,
    label: option,
  }));

  const formattedConsultationType = [
    { label: "IP Consultation", value: "IPD Consultation" },
    { label: "OP Consultation", value: "OPD Consultation" },
  ].map((option) => ({
    value: option.value,
    label: option.label,
  }));
  const [isFetchingBillDetails, setIsFetchingBillDetails] =
    useState<boolean>(false);

  useEffect(() => {
    const requestResponseDocuments = {
      requestedDocuments: [] as Document[],
      responseDocuments: [] as Document[],
    };

    documentTypes?.forEach((document) => {
      if (document?.requestDocument) {
        requestResponseDocuments.requestedDocuments.push(document);
      } else if (document?.responseDocument) {
        requestResponseDocuments.responseDocuments.push(document);
      }
    });

    setDocumentRequestResponseDocuments(requestResponseDocuments);
  }, [documentTypes]);

  const [isErrorState, setIsErrorState] = useState<boolean>(false);
  const lastErrorMessageRef = useRef<string | null>(null);

  useEffect(() => {
    if (isPreAuthTabActive()) {
      lastErrorMessageRef.current = null;
    }
  }, [activeKey]);

  const isPreAuthTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId,
    );

    setIsErrorState(currentStage?.state?.toLowerCase() === "error");

    return currentStage?.visitStage?.toUpperCase() === "PREAUTH";
  };

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id &&
      activeKey &&
      activeKey?.length > 0 &&
      isPreAuthTabActive()
    ) {
      dispatch(
        getPortalDataCghsNew({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  useEffect(() => {
    if (
      isErrorState &&
      preAuth?.portalData?.claimIdGenerationErrorMessage &&
      preAuth?.portalData?.claimIdGenerationErrorMessage !==
        lastErrorMessageRef.current &&
      isPreAuthTabActive()
    ) {
      errorMessageModal(preAuth?.portalData?.claimIdGenerationErrorMessage);
      lastErrorMessageRef.current =
        preAuth?.portalData?.claimIdGenerationErrorMessage;
    }
  }, [preAuth?.portalData, isErrorState, activeKey]);

  const handleGetClaimIdClick = () => {
    setGetClaimIdInitiated(true);
    setIsWaiting(true);

    setTimeout(() => {
      setIsWaiting(false);
    }, 60000);
  };

  useEffect(() => {
    const documentList = [
      ...documentTypes
        .filter(
          (item: any) => item.documentList && item.documentList.length > 0,
        )
        .flatMap((item: any, index: number) =>
          item.documentList!.map((doc: any, docIndex: any) => ({
            key: `${index + 1}`,
            label: item.label, // Document Type
            documentUrl: doc.documentUrl, // URL for download
            id: doc.id,
            documentType: doc.documentType,
            documentName: doc.documentName,
            deficiencyCheckStatus:
              doc.deficiencyCheckStatus === true
                ? true
                : doc.deficiencyCheckStatus === false
                  ? false
                  : null,
            deficiency:
              doc.deficiencyCheckStatus === true
                ? true
                : doc.deficiencyCheckStatus === false
                  ? false
                  : null,
            remarks: doc.remarks || null,
            documentLabelType: doc.documentLabelType,
            actions: item,
          })),
        ),
    ];

    setDocumentUrls(documentList);
  }, [documentTypes]);

  useEffect(() => {
    preAuth?.portalData?.casePreAuthCghs?.claimId
      ? setGetClaimIdInitiated(true)
      : (preAuth?.portalData?.message === "CasePreAuth Completed" ||
          preAuth?.portalData?.message === "CasePreAuth Submitted" ||
          preAuth?.portalData?.message === "PreAuth Initiated") &&
        setGetClaimIdInitiated(true);
  }, [
    preAuth?.portalData?.casePreAuthCghs?.claimId,
    preAuth?.portalData?.message,
  ]);

  const formattedDataSource: any = [
    // Process newly uploaded documents from documentUrls state
    ...documentUrls?.map((doc, index) => ({
      key: `${index + 1}`, // Unique key for new uploads
      label: doc.documentLabelType || "New Upload", // Use documentLabelType if available
      documentUrl: doc.documentUrl, // URL for download
      documentType: doc.documentType,
      id: doc.id,
      document: (
        <a href={doc.documentUrl} target="_blank" rel="noopener noreferrer">
          {doc.documentName}
        </a>
      ),
      deficiency:
        doc.deficiencyCheckStatus === true
          ? true
          : doc.deficiencyCheckStatus === false
            ? false
            : null,
      documentName: doc.documentName,
      deficiencyCheckStatus:
        doc.deficiencyCheckStatus === true
          ? true
          : doc.deficiencyCheckStatus === false
            ? false
            : null,
      documentLabelType: doc.documentLabelType,
      remarks: doc.remarks || "N/A",
      actions: {}, // Empty object for now
    })),
  ];

  useEffect(() => {
    if (
      preAuth?.portalData?.portalRegistrationStatus?.toUpperCase() ===
      "DISCREPANCY"
    ) {
      warningMessageModal("There is Mismatch in Registration Details");
    }
  }, [preAuth?.portalData?.portalRegistrationStatus]);

  const fetchDocuments = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      try {
        setLoading(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        );
        setDocumentTypes(AllDocumentList?.["PreAuth"]);
        setAllDocumentList(AllDocumentList);
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPreAuthTabActive())
      fetchDocuments();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    preAuth?.portalData,
    activeKey,
  ]);

  useEffect(() => {
    if (
      currentActiveStage?.visitStageId &&
      activeKey &&
      activeKey?.length > 0 &&
      isPreAuthTabActive()
    ) {
      dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId }),
      );
    }
  }, [currentActiveStage?.visitStageId, preAuth?.portalData, activeKey]);

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );

      dispatch(
        getPortalDataCghsNew({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
    fetchStepperForStatus();
    await getTimelineDetail();
    fetchDocuments();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any,
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );
        setFetchingDeficiencyData(true);
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId),
        );
        setFetchingDeficiencyData(false);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any,
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setPreviewDocumentUrl(documentUrl);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleOpen = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("document downloaded successfully");
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number,
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl,
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = combinedUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl,
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
        if (
          documentType?.toUpperCase() === "REFERRAL LETTER" &&
          patients?.fetchBasicDetails?.referralInfoResponse
        ) {
          const deletedForm = {
            echsReferralRequest: patients?.fetchBasicDetails
              ?.referralInfoResponse?.echsReferralResponse
              ? {
                  status: false,
                }
              : null,
            cghsReferralRequest: patients?.fetchBasicDetails
              ?.referralInfoResponse?.cghsReferralResponse
              ? {
                  status: false,
                }
              : null,
          };
          await deleteReferral(
            patients?.fetchBasicDetails?.casesResponse?.id,
            patients?.fetchBasicDetails?.referralInfoResponse
              ?.echsReferralResponse?.id ||
              patients?.fetchBasicDetails?.referralInfoResponse
                ?.cghsReferralResponse?.id,
            deletedForm,
          );
          if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
            await dispatch(
              getBasicDetails({
                id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              }),
            );
          }
        }
      } catch (err) {
        console.error(err);
        errorMessage("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  useEffect(() => {
    const getDoctorList = async () => {
      try {
        const res = await fetchDoctorListNew();
        setMedcoDoctor(res);
      } catch (err: any) {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    };

    const getGovtHospitalList = async () => {
      try {
        const res = await fetchGovtHospitalListNew();
        setGovtHospitalList(res);
      } catch (err: any) {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    };

    const getDiagnosisList = async () => {
      try {
        const res = await fetchDiagnosisListNew();
        setDiagnosisList(res);
      } catch (err: any) {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    };

    if (activeKey && activeKey?.length > 0 && isPreAuthTabActive()) {
      // getDoctorList();
      // getGovtHospitalList();
      // getDiagnosisList();
    }
  }, [activeKey]);

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
      activeKey &&
      activeKey?.length > 0 &&
      isPreAuthTabActive()
    ) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
        patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName &&
        patients?.fetchBasicDetails?.casesResponse?.healthCareId
      ) {
        dispatch(
          fetchProcedureNew({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            hospitalId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            isCghs:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                "CGHS NEW" ||
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                "CAPF NEW"
                ? true
                : false,
            procedureType:
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
                ? "OP"
                : "IP",
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
            benType: patients?.fetchBasicDetails?.patientResponse?.cardCategory
              ? patients?.fetchBasicDetails?.patientResponse?.cardCategory
                  ?.toLowerCase()
                  ?.includes("Gen"?.toLowerCase())
                ? "DGW"
                : patients?.fetchBasicDetails?.patientResponse?.cardCategory
                      ?.toLowerCase()
                      ?.includes("Private"?.toLowerCase())
                  ? "DPW"
                  : "DSPW"
              : null,
          }),
        );
      }
    }
  }, [
    hospital?.selectedHospital?.value,
    patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.patientSchemeId,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
    activeKey,
  ]);

  useEffect(() => {
    return () => {
      dispatch(resetProcedureDropdown());
    };
  }, []);

  const [isFetchingBillAuditProcedure, setIsFetchingBillAuditProcedure] =
    useState<boolean>(false);
  const [getProcedureFromBill, setGetProcedureFromBill] =
    useState<boolean>(false);

  const handleImportProcedureFromBill = () => {
    setGetProcedureFromBill(true);
  };

  const handleGetProcedureFromBill = async () => {
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        setIsFetchingBillAuditProcedure(true);
        const res = await getProcedureFromClaimNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
        );

        if (res?.length > 0) {
          const items = res?.map((procedureData: any, index: number) => {
            return {
              casePreAuthCghsProceduresId:
                procedureData?.casePreAuthCghsProceduresId,
              procedureId: index + 1,
              numberOfDays: "1",
              treatmentStartDate: patients?.fetchBasicDetails?.visitInfoResponse
                ?.doa
                ? dayjs(
                    patients?.fetchBasicDetails?.visitInfoResponse?.doa,
                    "DD-MM-YYYY HH:mm:ss",
                  )
                : null,
              accreditationStatus:
                // !patients?.fetchBasicDetails?.casesResponse?.healthCareName
                //   ?.toLowerCase()
                //   ?.includes("saroj gupta")
                //   ? "NABL~NABL"
                //   : "NON NABL~NON NABL",
                // "NABH~NABH",
                patients?.fetchBasicDetails?.casesResponse?.nablStatus
                  ? "NABL~NABL"
                  : patients?.fetchBasicDetails?.casesResponse?.nabhStatus
                    ? "NABH~NABH"
                    : "NON NABH~NON NABH",
              treatingDoctor: "OTHERS~OTHERS",
              procedureReferral: "referral~REFERRAL",
              externalProcedureCode: procedureData?.externalProcedureCode,
              strats: procedureData?.strats,
              procedureCode:
                procedureData?.id && procedureData?.procedureName //procedureData?.procedureCode
                  ? JSON.stringify({
                      procedureCode: procedureData?.procedureCode,
                      procedureName: procedureData?.procedureName,
                      procedureType: procedureData?.procedureType,
                      externalProcedureCode:
                        procedureData?.externalProcedureCode,
                      strats: procedureData?.strats,
                      id: Number(procedureData?.id),
                      nablStatus: procedureData?.nablStatus || null,
                    })
                  : null,
              stratsId: procedureData?.id,
              referralType: procedureData?.referralType,
              referralServiceName: procedureData?.referralServiceName,
            };
          });

          if (items && items?.length > 0) {
            try {
              const procedureAmounts = await Promise.all(
                items?.map(async (procedure: any) => {
                  if (
                    procedure?.externalProcedureCode &&
                    !procedure?.procedureName
                      ?.toLowerCase()
                      ?.includes("unspecified")
                  ) {
                    const baseFormData = {
                      procedureId: procedure.externalProcedureCode,
                      hospitalId:
                        patients?.fetchBasicDetails?.casesResponse
                          ?.healthCareId,
                      isCghs:
                        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "CGHS NEW",
                      schemeId:
                        patients?.fetchBasicDetails?.casesResponse
                          ?.schemeMetaDataId,
                      ward:
                        patients?.fetchBasicDetails?.patientResponse
                          ?.cardCategory || "Semi Private",
                    };

                    const tryApi = async (isNabl: boolean | null) => {
                      const formData = { ...baseFormData, isNabl };
                      try {
                        const result = await handleGetProcedureAmount(formData);
                        const amount =
                          isNabl === true
                            ? // result?.nablPackageAmount ||
                              result?.nabhPackageAmount
                            : result?.nonNabhPackageAmount;

                        if (amount) {
                          return { ...procedure, procedureAmount: amount };
                        }
                      } catch (err) {
                        // Ignore error and try fallback
                      }
                      return null;
                    };

                    let finalProcedure = await tryApi(
                      patients?.fetchBasicDetails?.casesResponse?.nabhStatus ||
                        patients?.fetchBasicDetails?.casesResponse?.nablStatus,
                    );
                    if (!finalProcedure) {
                      finalProcedure = await tryApi(
                        patients?.fetchBasicDetails?.casesResponse
                          ?.nabhStatus ||
                          patients?.fetchBasicDetails?.casesResponse
                            ?.nablStatus,
                      );
                    }

                    if (finalProcedure) {
                      return finalProcedure;
                    } else {
                      errorMessage(
                        "Unable to fetch procedure amount for: " +
                          procedure?.procedureCode,
                      );
                      return procedure; // Fallback to original without amount
                    }
                  } else {
                    return procedure;
                  }
                }),
              );

              form.setFieldsValue({ items: procedureAmounts });
            } catch (err) {
              form.setFieldsValue({ items });
            }
          }
        }
        setIsFetchingBillAuditProcedure(false);
        setGetProcedureFromBill(false);
      }
    } catch (err: any) {
      errorMessage(err?.message || "Please, Try again later");
      setIsFetchingBillAuditProcedure(false);
      setGetProcedureFromBill(false);
    }
  };

  // useEffect(() => {
  //   const getReferralProcedures = async () => {
  //     if (preAuthClaim?.referralProcedures?.length > 0) {
  //       const items = preAuthClaim?.referralProcedures?.map(
  //         (procedureData: any, index: number) => {
  //           return {
  //             procedureId: index + 1,
  //             numberOfDays: "1",
  //             treatmentStartDate: patients?.fetchBasicDetails?.visitInfoResponse
  //               ?.doa
  //               ? dayjs(
  //                   patients?.fetchBasicDetails?.visitInfoResponse?.doa,
  //                   "DD-MM-YYYY HH:mm:ss",
  //                 )
  //               : null,
  //             accreditationStatus:
  //               // !patients?.fetchBasicDetails?.casesResponse?.healthCareName
  //               //   ?.toLowerCase()
  //               //   ?.includes("saroj gupta")
  //               //   ? "NABL~NABL"
  //               //   : "NON NABL~NON NABL",
  //               patients?.fetchBasicDetails?.casesResponse?.nablStatus
  //                 ? "NABL~NABL"
  //                 : patients?.fetchBasicDetails?.casesResponse?.nabhStatus
  //                   ? "NABH~NABH"
  //                   : "NON NABH~NON NABH",
  //             treatingDoctor: "OTHERS~OTHERS",
  //             procedureReferral: "referral~REFERRAL",
  //             externalProcedureCode: procedureData?.externalProcedureCode,
  //             strats: procedureData?.strats,
  //             procedureCode:
  //               procedureData?.id && procedureData?.procedureName
  //                 ? JSON.stringify({
  //                     procedureCode: procedureData?.procedureCode,
  //                     procedureName: procedureData?.procedureName,
  //                     procedureType: procedureData?.procedureType,
  //                     externalProcedureCode:
  //                       procedureData?.externalProcedureCode,
  //                     strats: procedureData?.strats,
  //                     id: Number(procedureData?.id),
  //                     nablStatus: procedureData?.nablStatus || null,
  //                   })
  //                 : null,
  //             stratsId: procedureData?.id,
  //             referralType: procedureData?.referralType,
  //             referralServiceName: procedureData?.referralServiceName,
  //           };
  //         },
  //       );

  //       if (items && items?.length > 0) {
  //         try {
  //           const procedureAmounts = await Promise.all(
  //             items?.map(async (procedure: any) => {
  //               if (
  //                 procedure?.externalProcedureCode &&
  //                 !procedure?.procedureName
  //                   ?.toLowerCase()
  //                   ?.includes("unspecified")
  //               ) {
  //                 const baseFormData = {
  //                   procedureId: procedure.externalProcedureCode,
  //                   hospitalId:
  //                     patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  //                   isCghs:
  //                     patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
  //                     "CGHS NEW",
  //                   schemeId:
  //                     patients?.fetchBasicDetails?.casesResponse
  //                       ?.schemeMetaDataId,
  //                   ward:
  //                     patients?.fetchBasicDetails?.patientResponse
  //                       ?.cardCategory || "Semi Private",
  //                 };

  //                 const tryApi = async (isNabl: boolean | null) => {
  //                   const formData = { ...baseFormData, isNabl };
  //                   try {
  //                     const result = await handleGetProcedureAmount(formData);
  //                     const amount =
  //                       isNabl === true
  //                         ? // result?.nablPackageAmount ||
  //                           result?.nabhPackageAmount
  //                         : result?.nonNabhPackageAmount;

  //                     if (amount) {
  //                       return { ...procedure, procedureAmount: amount };
  //                     }
  //                   } catch (err) {
  //                     // Ignore error and try fallback
  //                   }
  //                   return null;
  //                 };

  //                 let finalProcedure = await tryApi(
  //                   patients?.fetchBasicDetails?.casesResponse?.nabhStatus ||
  //                     patients?.fetchBasicDetails?.casesResponse?.nablStatus,
  //                 );
  //                 if (!finalProcedure) {
  //                   finalProcedure = await tryApi(
  //                     patients?.fetchBasicDetails?.casesResponse?.nabhStatus ||
  //                       patients?.fetchBasicDetails?.casesResponse?.nablStatus,
  //                   );
  //                 }

  //                 if (finalProcedure) {
  //                   return finalProcedure;
  //                 } else {
  //                   errorMessage(
  //                     "Unable to fetch procedure amount for: " +
  //                       procedure?.procedureCode,
  //                   );
  //                   return procedure; // Fallback to original without amount
  //                 }
  //               } else {
  //                 return procedure;
  //               }
  //             }),
  //           );

  //           // const procedureAmounts = await Promise.all(
  //           //   items?.map(async (procedure: any) => {
  //           //     if (
  //           //       procedure?.externalProcedureCode &&
  //           //       !procedure?.procedureName
  //           //         ?.toLowerCase()
  //           //         ?.includes("unspecified")
  //           //     ) {
  //           //       const formData = {
  //           //         procedureId: procedure.externalProcedureCode,
  //           //         hospitalId:
  //           //           patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  //           //         isCghs:
  //           //           patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
  //           //           "CGHS"
  //           //             ? true
  //           //             : false,
  //           //         schemeId:
  //           //           patients?.fetchBasicDetails?.casesResponse
  //           //             ?.schemeMetaDataId,
  //           //         ward: "CSPW",
  //           //         isNabl:
  //           //           procedure?.accreditationStatus?.split("~")?.[1] === "NABL"
  //           //             ? true
  //           //             : procedure?.accreditationStatus?.split("~")?.[1] === "NON NABL"
  //           //             ? false
  //           //             : null,
  //           //       };

  //           //       let result;
  //           //       try {
  //           //         result = await handleGetProcedureAmount(formData);
  //           //       } catch (err) {
  //           //         const fallbackFormData = { ...formData, isNabl: false };
  //           //         try {
  //           //           result = await handleGetProcedureAmount(fallbackFormData);
  //           //         } catch (fallbackErr: any) {
  //           //           errorMessage(fallbackErr?.response?.data);
  //           //           return procedure;
  //           //         }
  //           //       }

  //           //       return {
  //           //         ...procedure,
  //           //         procedureAmount: !formData?.isNabl
  //           //           ? result?.nonNabhPackageAmount
  //           //           : result?.nablPackageAmount || result?.nabhPackageAmount,
  //           //       };

  //           //       // const result = await handleGetProcedureAmount(formData);
  //           //       // return {
  //           //       //   ...procedure,
  //           //       //   procedureAmount:
  //           //       //     result?.nablPackageAmount || result?.nabhPackageAmount,
  //           //       // };
  //           //     } else {
  //           //       return procedure;
  //           //     }
  //           //   })
  //           // );

  //           form.setFieldsValue({ items: procedureAmounts });
  //         } catch (err) {
  //           form.setFieldsValue({ items });
  //         }
  //       }
  //     }
  //   };

  //   if (
  //     preAuth?.portalData?.casePreAuthCghs?.casePreAuthCghsProceduresList
  //       ?.length === 0 ||
  //     !preAuth?.portalData
  //   ) {
  //     getReferralProcedures();
  //   }
  // }, [
  //   form,
  //   patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  //   patients?.fetchBasicDetails?.casesResponse?.healthCareName,
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.doa,
  //   preAuthClaim?.referralProcedures,
  //   preAuth?.portalData,
  //   activeKey,
  // ]);

  // useEffect(() => {
  //   form.setFieldsValue(preAuth?.portalData?.casePreAuthCghs);
  // }, [preAuth?.portalData])

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  useEffect(() => {
    if (!form.getFieldValue("beneficiaryId")) {
      form.setFieldValue(
        "beneficiaryId",
        preAuth?.portalData?.beneficiaryId ||
          patients?.fetchBasicDetails?.casesResponse?.memberId ||
          patients?.fetchBasicDetails?.referralInfoResponse
            ?.cghsReferralResponse?.beneficiaryId,
      );
    }

    if (!form.getFieldValue("patientOpdIpdNumber")) {
      form.setFieldValue(
        "patientOpdIpdNumber",
        preAuth?.portalData?.patientOpdIpdNumber ||
          patients?.fetchBasicDetails?.visitInfoResponse?.opNumber,
      );
    }

    if (!form.getFieldValue("remarks")) {
      form.setFieldValue(
        "remarks",
        patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
          "IP" ||
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
            "EMERGENCY"
          ? "IPD"
          : "OPD",
      );
    }

    if (!form.getFieldValue("referralNumber")) {
      form.setFieldValue(
        "referralNumber",
        preAuth?.portalData?.casePreAuthCghs?.referralNumber ||
          patients?.fetchBasicDetails?.referralInfoResponse
            ?.cghsReferralResponse?.refferenceID ||
          "N/A",
      );
    }

    if (!form.getFieldValue("referralDate")) {
      form.setFieldValue(
        "referralDate",
        preAuth?.portalData?.casePreAuthCghs?.referralDate
          ? dayjs(
              preAuth?.portalData?.casePreAuthCghs?.referralDate,
              "DD-MM-YYYY HH:mm:ss",
            )
          : patients?.fetchBasicDetails?.referralInfoResponse
                ?.cghsReferralResponse?.dateIssued
            ? dayjs(
                patients?.fetchBasicDetails?.referralInfoResponse
                  ?.cghsReferralResponse?.dateIssued,
                "DD-MM-YYYY",
              )
            : null,
      );
    }

    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
      "EMERGENCY"
    ) {
      if (!form.getFieldValue("visitType")) {
        form.setFieldValue("visitType", "EMG~EMERGENCY");
      }
    } else if (
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "IP"
    ) {
      if (!form.getFieldValue("visitType")) {
        form.setFieldValue("visitType", "PLN~PLANNED");
      }
    }

    if (!form.getFieldValue("proposedDate")) {
      form.setFieldValue(
        "proposedDate",
        patients?.fetchBasicDetails?.visitInfoResponse?.doa
          ? dayjs(
              patients?.fetchBasicDetails?.visitInfoResponse?.doa,
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
      );
    }

    if (!form.getFieldValue("patientDiagnosedBy")) {
      form.setFieldValue("patientDiagnosedBy", "Others");
    }

    if (!form.getFieldValue("isMedicoLegalCase")) {
      form.setFieldValue("isMedicoLegalCase", "false");
    }

    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
      "OP"
    ) {
      if (!form.getFieldValue("visitType")) {
        form.setFieldValue("visitType", "OPC~OPD Consultation");
      }

      if (!form.getFieldValue("procedureConsent")) {
        form.setFieldValue("procedureConsent", "false");
      }

      if (!form.getFieldValue("lastConsultation")) {
        form.setFieldValue("lastConsultation", "true");
      }

      if (!form.getFieldValue("consultationType")) {
        form.setFieldValue(
          "consultationType",
          "OPD Consultation~OP Consultation",
        );
      }

      if (!form.getFieldValue("primaryDiagnosis")) {
        form.setFieldValue("primaryDiagnosis", "O~Other");
      }

      if (!form.getFieldValue("diagnosisDescription")) {
        if (
          patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName
            ?.toLowerCase()
            ?.includes("dialysis")
        ) {
          form.setFieldValue("diagnosisDescription", "CKD");
        } else {
          form.setFieldValue("diagnosisDescription", "NA");
        }
      }
    } else {
      if (!form.getFieldValue("procedureConsent")) {
        form.setFieldValue("procedureConsent", "false");
      }

      if (!form.getFieldValue("consultationType")) {
        form.setFieldValue(
          "consultationType",
          "IPD Consultation~IP Consultation",
        );
      }
    }

    if (!form.getFieldValue("newBorn")) {
      form.setFieldValue("newBorn", "false");
    }

    if (!form.getFieldValue("referralType")) {
      form.setFieldValue("referralType", "e-referral");
    }

    // if (!form.getFieldValue("referralType")) {
    //   form.setFieldValue(
    //     "referralType",
    //     patients?.fetchBasicDetails?.referralInfoResponse?.cghsReferralResponse
    //       ?.id
    //       ? "e-referral"
    //       : "manual"
    //   );
    // }

    if (!form.getFieldValue("referralBy")) {
      if (
        patients?.fetchBasicDetails?.referralInfoResponse?.cghsReferralResponse
          ?.referralBy
      ) {
        form.setFieldValue(
          "referralBy",
          patients?.fetchBasicDetails?.referralInfoResponse
            ?.cghsReferralResponse?.referralBy,
        );
      }
    }
  }, [
    patients?.fetchBasicDetails?.referralInfoResponse?.cghsReferralResponse,
    patients?.fetchBasicDetails?.visitInfoResponse?.opNumber,
    patients?.fetchBasicDetails?.visitInfoResponse?.doa,
    preAuth?.portalData,
    patients?.fetchBasicDetails,
  ]);

  const selectedDoctor = Form.useWatch("selectedDoctor", form);

  if (!selectedDoctor) {
    form.setFieldValue("selectedDoctor", "other");
  }

  useEffect(() => {
    if (
      preAuth?.portalData?.casePreAuthCghs &&
      preAuth?.portalData?.casePreAuthCghs?.id
    ) {
      //   props?.setClaimId(preAuth?.portalData?.casePreAuthCghs?.claimId);
      // 05/05/2025 - commented claimId
      const updatedItems =
        preAuth?.portalData?.casePreAuthCghs?.casePreAuthCghsProceduresList?.map(
          (procedureData: any, index: number) => {
            return {
              ...procedureData,
              numberOfDays: procedureData?.numberOfDays
                ? Math.ceil(procedureData.numberOfDays)
                : 1,
              treatmentStartDate: procedureData?.treatmentStartDate
                ? dayjs(
                    procedureData?.treatmentStartDate,
                    "DD-MM-YYYY HH:mm:ss",
                  )
                : null,
              accreditationStatus: procedureData?.accreditationStatus
                ? procedureData?.accreditationStatus +
                  "~" +
                  procedureData?.accreditationStatus
                : null,
              treatingDoctor: procedureData?.treatingDoctorName
                ? procedureData?.treatingDoctorName +
                  "~" +
                  procedureData?.treatingDoctorCode
                : null,
              procedureReferral: procedureData?.procedureReferral
                ? procedureData?.procedureReferral +
                  "~" +
                  procedureData?.procedureReferralName
                : null,
              externalProcedureCode: procedureData?.externalProcedureCode,
              strats: procedureData?.strats,
              isAmountAutoFilled: procedureData?.procedureAmount ? true : false,
              procedureCode:
                procedureData?.id && procedureData?.procedureName
                  ? JSON.stringify({
                      procedureCode: procedureData?.procedureCode,
                      procedureName: procedureData?.procedureName,
                      procedureType: procedureData?.procedureType,
                      externalProcedureCode:
                        procedureData?.externalProcedureCode,
                      strats: procedureData?.strats,
                      id:
                        Number(procedureData?.stratsId) ||
                        Number(procedureData?.procedureId),
                      nablStatus:
                        procedureData?.nablStatus === "true"
                          ? true
                          : procedureData?.nablStatus === "false"
                            ? false
                            : null,
                      specialityType: procedureData?.specialityType,
                    })
                  : null,
              stratsId: procedureData?.stratsId,
              pid: procedureData?.id,
            };
          },
        );
      form.setFieldsValue({
        ...preAuth?.portalData,
        ...preAuth?.portalData?.casePreAuthCghs,
        proposedDate: preAuth?.portalData?.casePreAuthCghs?.proposedDate
          ? dayjs(
              preAuth?.portalData?.casePreAuthCghs?.proposedDate,
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        referralDate: preAuth?.portalData?.casePreAuthCghs?.referralDate
          ? dayjs(
              preAuth?.portalData?.casePreAuthCghs?.referralDate,
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        primaryDiagnosis: preAuth?.portalData?.casePreAuthCghs
          ?.primaryDiagnosisCode
          ? preAuth?.portalData?.casePreAuthCghs?.primaryDiagnosisCode +
            "~" +
            preAuth?.portalData?.casePreAuthCghs?.primaryDiagnosisName
          : null,
        isMedicoLegalCase:
          preAuth?.portalData?.casePreAuthCghs?.isMedicoLegalCase?.toString(),
        procedureConsent:
          preAuth?.portalData?.casePreAuthCghs?.procedureConsent?.toString(),
        newBorn: preAuth?.portalData?.casePreAuthCghs?.newBorn?.toString(),
        items: updatedItems,
        lastConsultation: preAuth?.portalData?.casePreAuthCghs?.lastConsultation
          ? "true"
          : "false",
        visitType: preAuth?.portalData?.casePreAuthCghs?.visitType
          ? preAuth?.portalData?.casePreAuthCghs?.visitType +
            "~" +
            preAuth?.portalData?.casePreAuthCghs?.visitTypeName
          : null,
        govtHospital: preAuth?.portalData?.casePreAuthCghs?.govtHospitalCode
          ? preAuth?.portalData?.casePreAuthCghs?.govtHospitalCode +
            "~" +
            preAuth?.portalData?.casePreAuthCghs?.govtHospitalName
          : null,
        surgeryTreatmentStartDate: preAuth?.portalData?.casePreAuthCghs
          ?.surgeryTreatmentStartDate
          ? dayjs(
              preAuth?.portalData?.casePreAuthCghs?.surgeryTreatmentStartDate,
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        admissionDate: preAuth?.portalData?.casePreAuthCghs?.admissionDate
          ? dayjs(
              preAuth?.portalData?.casePreAuthCghs?.admissionDate,
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        referralNumber:
          preAuth?.portalData?.casePreAuthCghs?.referralNumber || "N/A",
        remarks: preAuth?.portalData?.casePreAuthCghs?.remarks
          ? preAuth?.portalData?.casePreAuthCghs?.remarks
          : patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                "IP" ||
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                "EMERGENCY"
            ? "IPD"
            : "OPD",
      });
    }
  }, [preAuth?.portalData]);

  useEffect(() => {
    const diag = preAuth?.portalData?.casePreAuthCghs?.diagnosisData;
    if (Array.isArray(diag) && diag.length > 0) {
      // Normalize backend shape to match UI expectations: { diagnosis, diagnosisCode, type }
      const normalized = diag.map((d: any) => ({
        diagnosis:
          d?.diagnosis || d?.diagnosisDescription || d?.diagnosisName || "",
        diagnosisCode: d?.diagnosisCode || d?.diagnosisId || d?.code || "",
        type: d?.type || d?.diagnosisType || "Secondary",
      }));
      setDiagnosisData(normalized);
    }
  }, [preAuth?.portalData?.casePreAuthCghs?.diagnosisData]);

  useEffect(() => {
    if (!form.getFieldValue("govtHospital")) {
      if (
        patients?.fetchBasicDetails?.referralInfoResponse?.cghsReferralResponse
          ?.id &&
        patients?.fetchBasicDetails?.referralInfoResponse?.cghsReferralResponse
          ?.refferenceID
      ) {
        const hospitalCode =
          patients?.fetchBasicDetails?.referralInfoResponse?.cghsReferralResponse?.refferenceID?.split(
            "/",
          )[0];
        const res = govtHospitalList?.find(
          (option: any) => option?.govtHospitalCode === hospitalCode,
        );
        if (res) {
          form.setFieldValue(
            "govtHospital",
            res?.govtHospitalCode + "~" + res?.govtHospitalName,
          );
        }
      }
    }
  }, [govtHospitalList, patients?.fetchBasicDetails]);

  const formattedAccreditationOptions: Array<{ label: string; value: string }> =
    [
      { label: "NABH", value: "NABH" },
      { label: "NABL", value: "NABL" },
      { label: "NON NABL", value: "NON NABL" },
      { label: "NON NABH", value: "NON NABH" },
    ].map((option) => ({
      value: option?.value + "~" + option?.label,
      label: option.label,
    }));

  const formattedTreatingDoctorsOptions: Array<{
    label: string;
    value: string;
  }> = [{ treatingDoctorCode: "OTHERS", treatingDoctorName: "OTHERS" }]?.map(
    (option) => ({
      value: option?.treatingDoctorCode + "~" + option?.treatingDoctorName,
      label: option?.treatingDoctorName,
    }),
  );

  const formattedProcedureReferral: Array<{ label: string; value: string }> = [
    { label: "REFERRAL", value: "referral" },
    { label: "NON REFERRAL", value: "non referral" },
  ].map((option) => ({
    value: option?.value + "~" + option?.label,
    label: option.label,
  }));

  const formattedProceduresOptions: Array<{
    label: string;
    value: string;
    extra?: any;
  }> = preAuthClaim?.procedureDropDown
    ? preAuthClaim?.procedureDropDown?.map((option: any) => ({
        value: JSON.stringify({
          procedureCode: option?.procedureCode,
          procedureName: option?.procedureName,
          procedureType: option?.procedureType,
          externalProcedureCode: option?.externalProcedureCode,
          strats: option?.strats,
          id: Number(option?.id),
          nablStatus: null, //option?.nablStatus ||
          specialityType: option?.specialityType || null,
        }),
        label: option?.procedureName,
        extra: {
          amount: option.specialityType?.toLowerCase()?.includes("s")
            ? null
            : option?.amount,
        },
      }))
    : [];

  const handleGetProcedureAmount = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW"
            ? true
            : false,
      };
      const procedureAmountRes = await getProcedureAmountNew(newFormData);
      return procedureAmountRes;
    } catch (err: any) {
      // errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  const handleGetProcedureStrats = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW"
            ? true
            : false,
      };
      const procedureStrats = await getStratsDataNew(newFormData);
      setProcedureStrats((prevStrats) => ({
        ...prevStrats,
        [formData.procedureId]: procedureStrats,
      }));
      return procedureStrats;
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  const handleDeleteProcedure = async (procedureBackendId: number) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        await deleteProcedureCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          {
            id: procedureBackendId,
            status: false,
          },
        );

        successMessage("Procedure deleted successfully");
        return true;
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
      return false;
    }
  };

  const handleNext = async () => {
    // try {
    //   await form.validateFields();
    //   setActiveStep(activeStep + 1);
    // } catch (err: any) {
    //   if (err?.errorFields) {
    //     errorMessage("Please, Fill after details before continuing");
    //   }
    // }
    if (activeStep === 2 && !preAuth?.portalData?.casePreAuthCghs?.claimId) {
      setOpen(true);
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handlePrevious = async () => {
    // try{
    //   await form.validateFields();
    //   setActiveStep(activeStep - 1);
    // }
    // catch(err: any) {
    //   if(err?.errorFields) {
    //     errorMessage("Please, Fill after details before continuing");
    //   }
    // }
    setActiveStep(activeStep - 1);
  };

  const updateOrAddDocument = (
    uploadedDocumentUrl: any,
    documentRes: IDocumentFields,
  ) => {
    const updatedDocuments = [...uploadedDocumentUrl];

    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });

    // Return the updated array (ensures it's a flat array)
    return updatedDocuments;
  };

  const handleUpload = async () => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file),
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        setUploadFileList([]);
        setSelectedFiles([]);
        setPreviewFiles([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        await handleAttachDocuments(documentRes);
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  // const handleUpload = async () => {
  //   const CollectPostData = new FormData();
  //   if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
  //     CollectPostData.append(
  //       "hospitalId",
  //       patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.patientResponse?.id) {
  //     CollectPostData.append(
  //       "patientId",
  //       patients?.fetchBasicDetails?.patientResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.casesResponse?.id) {
  //     CollectPostData.append(
  //       "caseId",
  //       patients?.fetchBasicDetails?.casesResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
  //     CollectPostData.append(
  //       "visitId",
  //       patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
  //     );
  //   }
  //   CollectPostData.append("documentType", previewFile.documentType);

  //   if (selectedFile?.file) {
  //     CollectPostData.append("file", selectedFile?.file);
  //   }

  //   try {
  //     const documentRes = await dispatch(
  //       UploadDocument({
  //         formData: CollectPostData,
  //         accessToken: auth.accessToken || "",
  //       })
  //     ).unwrap();

  //     const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);

  //     setDocumentUrls(updatedDocuments);
  //     setPreviewModalVisible(false);
  //     message.success(
  //       `${documentRes?.documentLabelType} uploaded successfully`
  //     );
  //   } catch (error) {
  //     console.error("Failed to upload document:", error);
  //   }
  // };

  const handleUploadDocument = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal) {
      try {
        await form.validateFields();
        // if (diagnosisData?.length === 0) {
        //   errorMessage("Please, Fill Diagnosis data");
        //   return;
        // }
        setIsSubmittedOnPortal(true);
      } catch (err: any) {
        if (err?.errorFields) {
          errorMessage("Please, Fill details before submitting");
        } else {
          console.error(err);
          errorMessage("Please, Try again later");
        }
      }
    } else {
      // setManuallyClaimIdPortal(true);
      setConfirmationModal(true);
      setConfirmationState("submit");
      setTitle("Do You want to submit PreAuth ?");
    }
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const handleEnterClick = () => {
    setOpen(false);
    setActiveStep(activeStep + 1);
  };

  const handleCancelPortal = () => {
    setOpen(false);
  };

  const handleManuallyIdEnter = () => {
    setIsSubmittedOnPortal(false);
    setIsManuallyEnteredId(true);
  };

  const handleCancelSubmissionPortal = () => {
    setIsSubmittedOnPortal(false);
    setSubmissionModal(true);
  };

  const handleCancelManuallyId = () => {
    setIsManuallyEnteredId(false);
  };

  const handleOk = () => {
    setSubmissionModal(false);
  };

  const handleRegistrationCancel = () => {
    setSubmissionModal(false);
    setIsSubmittedOnPortal(false);
  };

  const validateForm = () => {
    const newErrors: any = {};
    const requiredDocuments = getStarmarkOptions()?.filter(
      (doc: any) => (doc?.hasOwnProperty("required") ? doc?.required : true), //doc?.required
    );

    requiredDocuments?.forEach((doc: any) => {
      const docExists = documentUrls?.some(
        (item) => item?.documentLabelType === doc.label,
      );
      if (!docExists) {
        newErrors[doc.value] = `${doc.label} is required`;
      }
    });

    return Object.keys(newErrors).length === 0;
  };

  const handleAttachDocuments = async (updatedDocumentUrls: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    payloadSchema["casePreAuthAttachments"] = updatedDocumentUrls;

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema,
        );
        message.success(`documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveData = async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    const updatedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType,
      ),
    );

    payloadSchema["casePreAuthAttachments"] = updatedDocumentUrls;

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema,
        );
        message.success(`Response documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveModalOption = async () => {
    try {
      await form.validateFields();
      // if (diagnosisData?.length === 0) {
      //   errorMessage("Please, Fill Diagnosis data");
      //   setSubmissionModal(false);
      //   setIsSubmittedOnPortal(false);
      //   setIsSubmitting(false);
      //   return;
      // }
      const values = await form.getFieldsValue(true);
      if (validateForm()) {
        setIsSubmittedOnPortal(true);
        const totalAmount =
          await form.getFieldsValue(true)?.totalIntimatedAmount;

        const documentData = documentUrls?.reduce((acc: any, list: any) => {
          switch (list?.documentLabelType) {
            case "CGHS CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "CAPF CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "REFERRAL LETTER":
              acc.linkReferralSlip = list?.documentUrl;
              acc.linkReferralSlipDocId = list?.id;
              break;
            case "CONSENT FORM":
              acc.linkProcedureConsentFile = list?.documentUrl;
              acc.linkProcedureConsentFileDocId = list?.id;
              break;
            case "EMERGENCY LETTER":
              acc.linkEmergencyLetterFile = list?.documentUrl;
              acc.linkEmergencyLetterFileDocId = list?.id;
              break;
            case "Justification for unspecified package":
              acc.linkJustificationLetterFile = list?.documentUrl;
              acc.linkJustificationLetterFileDocId = list?.id;
              break;
            case "OTHERS":
            default:
              acc.linkOtherDocument = list?.documentUrl;
              acc.linkOtherDocumentDocId = list?.id;
              break;
          }
          return acc;
        }, {});

        const updatedItems =
          values?.items
            ?.map((item: any, index: number) => {
              let parsedProcedureCode: any = {};

              if (typeof item?.procedureCode === "string") {
                try {
                  parsedProcedureCode = JSON.parse(item.procedureCode);
                } catch {
                  return null;
                }
              }

              if (!parsedProcedureCode?.procedureName) {
                return null;
              }

              return {
                ...item,
                casePreAuthCghsProceduresId: null,
                procedureId: parsedProcedureCode?.id,
                accreditationStatus: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[0]
                  : null,
                accreditationStatusName: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[1]
                  : null,
                treatingDoctorCode: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[0]
                  : null,
                treatingDoctorName: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[1]
                  : null,
                procedureReferral: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[0]
                  : null,
                procedureReferralName: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[1]
                  : null,
                stratsId: parsedProcedureCode?.id,
                treatmentStartDate: item?.treatmentStartDate
                  ? dayjs(item?.treatmentStartDate).format(
                      "DD-MM-YYYY HH:mm:ss",
                    )
                  : null,
                ...parsedProcedureCode,
                id: item?.casePreAuthCghsProceduresId || item?.pid || null,
              };
            })
            ?.filter(Boolean) || [];
        const updatedValues = {
          ...values,
          primaryDiagnosisCode: values?.primaryDiagnosis
            ? values?.primaryDiagnosis?.split("~")?.[0]
            : null,
          primaryDiagnosisName: values?.primaryDiagnosis
            ? values?.primaryDiagnosis?.split("~")?.[1]
            : null,
          doctorCode: values?.doctor ? values?.doctor?.split("~")?.[0] : null,
          // doctorName: values?.doctor ? values?.doctor?.split("~")?.[1] : null,
          govtHospitalCode: values?.govtHospital
            ? values?.govtHospital?.split("~")?.[0]
            : null,
          govtHospitalName: values?.govtHospital
            ? values?.govtHospital?.split("~")?.[1]
            : null,
          consultationType: values?.consultationType
            ? values?.consultationType?.split("~")?.[0]
            : null,
          consultationTypeName: values?.consultationType
            ? values?.consultationType?.split("~")?.[1]
            : null,
          visitType: values?.visitType
            ? values?.visitType?.split("~")?.[0]
            : null,
          visitTypeName: values?.visitType
            ? values?.visitType?.split("~")?.[1]
            : null,
          totalIntimatedAmount: totalAmount,
          proposedDate: values?.proposedDate
            ? dayjs(values?.proposedDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          referralDate: values?.referralDate
            ? dayjs(values?.referralDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          casePreAuthCghsProceduresList: updatedItems,
          listofResponseUrl: documentUrls,
          ...documentData,
          casePreAuthRequest: {
            beneficiaryId: values?.beneficiaryId,
            patientOpdIpdNumber: values?.patientOpdIpdNumber,
            totalAmount: totalAmount,
          },
          manualPreAuth: false,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          surgeryTreatmentStartDate: values?.surgeryTreatmentStartDate
            ? dayjs(values?.surgeryTreatmentStartDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          admissionDate: values?.admissionDate
            ? dayjs(values?.admissionDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          diagnosisData,
        };

        if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          const payload = {
            schemeMetaDataId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
            portalMetaDataId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
            casePreAuthId: preAuth?.portalData?.casePreAuthCghs
              ?.casePreAuthResponse?.id
              ? preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.id
              : 0,
            casePreAuthIhxRequest: null,
            casePreAuthCghsRequest: updatedValues,
            casePreAuthVidalRequest: null,
            casePreAuthStarhealthRequest: null,
            casePreAuthEchsRequest: null,
            totalAmount: totalAmount,
            integratedWithPortal:
              patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
          };

          const res = await validationPreAuth(
            patients?.fetchBasicDetails?.casesResponse?.id,
            patients?.fetchBasicDetails?.visitInfoResponse?.id,
            payload,
          );

          if (res?.success) {
            setIsSubmitting(true);
            const resp = await fetchPreAuthToPortalCghsNew(
              patients?.fetchBasicDetails?.casesResponse?.id,
              patients?.fetchBasicDetails?.visitInfoResponse?.id,
              payload,
            );
            successMessage("PreAuth Submitted Successfully");
            setConfirmationModal(false);
            setIsSubmitting(false);
            setIsSubmittedOnPortal(false);
            // handleGetClaimIdClick();
            if (resp) {
              dispatch(
                getPortalDataCghsNew({
                  caseId: patients?.fetchBasicDetails?.casesResponse?.id,
                  visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
              fetchDocuments();
              await getTimelineDetail();
              await fetchStepperForStatus();
              dispatch(
                getBasicDetails({
                  id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
            }
          } else if (res?.message === "Registration id not found") {
            errorMessage("Registration Id is not found");
            setIsSubmittedOnPortal(false);
            return;
          }
        }
      } else {
        errorMessage("Please, Upload All Required Documents");
        setSubmissionModal(false);
        setIsSubmittedOnPortal(false);
        setIsSubmitting(false);
        return;
      }
    } catch (err: any) {
      if (err.errorFields) {
        errorMessage("Please, Fill All details before submitting");
      } else {
        console.error(err);
        errorMessage(err?.message || "Please, Try again later");
      }
      setIsLoading(false);
    }
    setSubmissionModal(false);
    setIsSubmittedOnPortal(false);
    setIsSubmitting(false);
  };

  const handleSaveManually = async () => {
    //values: any
    try {
      await form.validateFields();
      // if (diagnosisData?.length === 0) {
      //   errorMessage("Please, Fill Diagnosis data");
      //   setIsManuallyEnteredId(false);
      //   setIsSubmitting(false);
      //   setManuallyClaimIdPortal(false);
      //   return;
      // }
      const preAuthFormValues = await form.getFieldsValue(true);
      if (validateForm()) {
        const totalAmount =
          await form.getFieldsValue(true)?.totalIntimatedAmount;
        const documentData = documentUrls?.reduce((acc: any, list: any) => {
          switch (list?.documentLabelType) {
            case "CGHS CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "CAPF CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "REFERRAL LETTER":
              acc.linkReferralSlip = list?.documentUrl;
              acc.linkReferralSlipDocId = list?.id;
              break;
            case "CONSENT FORM":
              acc.linkProcedureConsentFile = list?.documentUrl;
              acc.linkProcedureConsentFileDocId = list?.id;
              break;
            case "EMERGENCY LETTER":
              acc.linkEmergencyLetterFile = list?.documentUrl;
              acc.linkEmergencyLetterFileDocId = list?.id;
              break;
            case "Justification for unspecified package":
              acc.linkJustificationLetterFile = list?.documentUrl;
              acc.linkJustificationLetterFileDocId = list?.id;
              break;
            case "OTHERS":
            default:
              acc.linkOtherDocument = list?.documentUrl;
              acc.linkOtherDocumentDocId = list?.id;
              break;
          }
          return acc;
        }, {});

        const updatedItems =
          preAuthFormValues?.items
            ?.map((item: any, index: number) => {
              let parsedProcedureCode: any = {};

              if (typeof item?.procedureCode === "string") {
                try {
                  parsedProcedureCode = JSON.parse(item.procedureCode);
                } catch {
                  return null;
                }
              }

              if (!parsedProcedureCode?.procedureName) {
                return null;
              }
              return {
                ...item,
                casePreAuthCghsProceduresId: null,
                procedureId: parsedProcedureCode?.id,
                accreditationStatus: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[0]
                  : null,
                accreditationStatusName: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[1]
                  : null,
                treatingDoctorCode: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[0]
                  : null,
                treatingDoctorName: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[1]
                  : null,
                procedureReferral: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[0]
                  : null,
                procedureReferralName: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[1]
                  : null,
                stratsId: parsedProcedureCode?.id,
                treatmentStartDate: item?.treatmentStartDate
                  ? dayjs(item?.treatmentStartDate).format(
                      "DD-MM-YYYY HH:mm:ss",
                    )
                  : null,
                ...parsedProcedureCode,
                id: item?.casePreAuthCghsProceduresId || item?.pid || null,
              };
            })
            ?.filter(Boolean) || [];
        const updatedValues = {
          ...preAuthFormValues,
          primaryDiagnosisCode: preAuthFormValues?.primaryDiagnosis
            ? preAuthFormValues?.primaryDiagnosis?.split("~")?.[0]
            : null,
          primaryDiagnosisName: preAuthFormValues?.primaryDiagnosis
            ? preAuthFormValues?.primaryDiagnosis?.split("~")?.[1]
            : null,
          doctorCode: preAuthFormValues?.doctor
            ? preAuthFormValues?.doctor?.split("~")?.[0]
            : null,
          // doctorName: preAuthFormValues?.doctor
          //   ? preAuthFormValues?.doctor?.split("~")?.[1]
          //   : null,
          govtHospitalCode: preAuthFormValues?.govtHospital
            ? preAuthFormValues?.govtHospital?.split("~")?.[0]
            : null,
          govtHospitalName: preAuthFormValues?.govtHospital
            ? preAuthFormValues?.govtHospital?.split("~")?.[1]
            : null,
          consultationType: preAuthFormValues?.consultationType
            ? preAuthFormValues?.consultationType?.split("~")?.[0]
            : null,
          consultationTypeName: preAuthFormValues?.consultationType
            ? preAuthFormValues?.consultationType?.split("~")?.[1]
            : null,
          visitType: preAuthFormValues?.visitType
            ? preAuthFormValues?.visitType?.split("~")?.[0]
            : null,
          visitTypeName: preAuthFormValues?.visitType
            ? preAuthFormValues?.visitType?.split("~")?.[1]
            : null,
          totalIntimatedAmount: totalAmount,
          proposedDate: preAuthFormValues?.proposedDate
            ? dayjs(preAuthFormValues?.proposedDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          referralDate: preAuthFormValues?.referralDate
            ? dayjs(preAuthFormValues?.referralDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          casePreAuthCghsProceduresList: updatedItems,
          listofResponseUrl: documentUrls,
          casePreAuthRequest: {
            beneficiaryId: preAuthFormValues?.beneficiaryId,
            patientOpdIpdNumber: preAuthFormValues?.patientOpdIpdNumber,
            totalAmount: totalAmount,
          },
          ...documentData,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
          surgeryTreatmentStartDate:
            preAuthFormValues?.surgeryTreatmentStartDate
              ? dayjs(preAuthFormValues?.surgeryTreatmentStartDate).format(
                  "DD-MM-YYYY HH:mm:ss",
                )
              : null,
          admissionDate: preAuthFormValues?.admissionDate
            ? dayjs(preAuthFormValues?.admissionDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          diagnosisData,
        };

        if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          const updatedData = {
            ...updatedValues,
            manualPreAuth: true,
            claimId: preAuth?.portalData?.casePreAuthCghs?.claimId, //values?.manualId
          };

          const payload = {
            schemeMetaDataId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
            portalMetaDataId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            casePreAuthId: preAuth?.portalData?.casePreAuthCghs
              ?.casePreAuthResponse?.id
              ? preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.id
              : 0,
            casePreAuthIhxRequest: null,
            casePreAuthCghsRequest: updatedData,
            casePreAuthVidalRequest: null,
            casePreAuthStarhealthRequest: null,
            casePreAuthEchsRequest: null,
            totalAmount: totalAmount,
            integratedWithPortal:
              patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
          };

          const res = await validationPreAuth(
            patients?.fetchBasicDetails?.casesResponse?.id,
            patients?.fetchBasicDetails?.visitInfoResponse?.id,
            payload,
          );

          if (res?.success) {
            setIsSubmitting(true);
            const resp = await fetchPreAuthToPortalCghsNew(
              patients?.fetchBasicDetails?.casesResponse?.id,
              patients?.fetchBasicDetails?.visitInfoResponse?.id,
              payload,
            );
            successMessage("PreAuth Submitted Successfully");
            setConfirmationModal(false);
            setManuallyClaimIdPortal(false);
            setIsSubmitting(false);
            handleGetClaimIdClick();
            if (resp) {
              dispatch(
                getPortalDataCghsNew({
                  caseId: patients?.fetchBasicDetails?.casesResponse?.id,
                  visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
              fetchDocuments();
              await getTimelineDetail();
              await fetchStepperForStatus();
              dispatch(
                getBasicDetails({
                  id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                }),
              );
            }
          } else if (res?.message === "Registration id not found") {
            errorMessage("Registration Id is not found");
            setIsSubmitting(false);
            return;
          }
        }
      } else {
        errorMessage("Please, Upload All Required Documents");
        setIsManuallyEnteredId(false);
        setIsSubmitting(false);
        setManuallyClaimIdPortal(false);
        return;
      }

      setIsManuallyEnteredId(false);
      setIsSubmitting(false);
      setManuallyClaimIdPortal(false);
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please Fill all details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
    }
    setIsSubmitting(false);
    setIsManuallyEnteredId(false);
    setManuallyClaimIdPortal(false);
  };

  const handleSaveAsDraft = async () => {
    try {
      // const values = await form.validateFields();
      const values = await form.getFieldsValue(true);
      const totalAmount = await form.getFieldsValue(true)?.totalIntimatedAmount;

      const documentData = documentUrls?.reduce((acc: any, list: any) => {
        switch (list?.documentLabelType) {
          case "CGHS CARD":
            acc.linkCghsCard = list?.documentUrl;
            acc.linkCghsCardDocId = list?.id;
            break;
          case "CAPF CARD":
            acc.linkCghsCard = list?.documentUrl;
            acc.linkCghsCardDocId = list?.id;
            break;
          case "REFERRAL LETTER":
            acc.linkReferralSlip = list?.documentUrl;
            acc.linkReferralSlipDocId = list?.id;
            break;
          case "CONSENT FORM":
            acc.linkProcedureConsentFile = list?.documentUrl;
            acc.linkProcedureConsentFileDocId = list?.id;
            break;
          case "EMERGENCY LETTER":
            acc.linkEmergencyLetterFile = list?.documentUrl;
            acc.linkEmergencyLetterFileDocId = list?.id;
            break;
          case "Justification for unspecified package":
            acc.linkJustificationLetterFile = list?.documentUrl;
            acc.linkJustificationLetterFileDocId = list?.id;
            break;
          case "OTHERS":
          default:
            acc.linkOtherDocument = list?.documentUrl;
            acc.linkOtherDocumentDocId = list?.id;
            break;
        }
        return acc;
      }, {});

      const updatedItems =
        values?.items
          ?.map((item: any, index: number) => {
            let parsedProcedureCode: any = {};

            if (typeof item?.procedureCode === "string") {
              try {
                parsedProcedureCode = JSON.parse(item.procedureCode);
              } catch {
                return null;
              }
            }

            if (!parsedProcedureCode?.procedureName) {
              return null;
            }

            return {
              ...item,
              procedureId: parsedProcedureCode?.id,
              accreditationStatus: item?.accreditationStatus
                ? item?.accreditationStatus?.split("~")?.[0]
                : null,
              accreditationStatusName: item?.accreditationStatus
                ? item?.accreditationStatus?.split("~")?.[1]
                : null,
              treatingDoctorCode: item?.treatingDoctor
                ? item?.treatingDoctor?.split("~")?.[0]
                : null,
              treatingDoctorName: item?.treatingDoctor
                ? item?.treatingDoctor?.split("~")?.[1]
                : null,
              procedureReferral: item?.procedureReferral
                ? item?.procedureReferral?.split("~")?.[0]
                : null,
              procedureReferralName: item?.procedureReferral
                ? item?.procedureReferral?.split("~")?.[1]
                : null,
              stratsId: parsedProcedureCode?.id,
              treatmentStartDate: item?.treatmentStartDate
                ? dayjs(item?.treatmentStartDate).format("DD-MM-YYYY HH:mm:ss")
                : null,
              ...parsedProcedureCode,
              id: item?.pid || null,
            };
          })
          ?.filter(Boolean) || [];
      const updatedValues = {
        ...values,
        primaryDiagnosisCode: values?.primaryDiagnosis
          ? values?.primaryDiagnosis?.split("~")?.[0]
          : null,
        primaryDiagnosisName: values?.primaryDiagnosis
          ? values?.primaryDiagnosis?.split("~")?.[1]
          : null,
        doctorCode: values?.doctor ? values?.doctor?.split("~")?.[0] : null,
        // doctorName: values?.doctor ? values?.doctor?.split("~")?.[1] : null,
        govtHospitalCode: values?.govtHospital
          ? values?.govtHospital?.split("~")?.[0]
          : null,
        govtHospitalName: values?.govtHospital
          ? values?.govtHospital?.split("~")?.[1]
          : null,
        consultationType: values?.consultationType
          ? values?.consultationType?.split("~")?.[0]
          : null,
        consultationTypeName: values?.consultationType
          ? values?.consultationType?.split("~")?.[1]
          : null,
        visitType: values?.visitType
          ? values?.visitType?.split("~")?.[0]
          : null,
        visitTypeName: values?.visitType
          ? values?.visitType?.split("~")?.[1]
          : null,
        totalIntimatedAmount: totalAmount,
        proposedDate: values?.proposedDate
          ? dayjs(values?.proposedDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        referralDate: values?.referralDate
          ? dayjs(values?.referralDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        casePreAuthCghsProceduresList: updatedItems,
        listofResponseUrl: documentUrls,
        ...documentData,
        casePreAuthRequest: {
          beneficiaryId: values?.beneficiaryId,
          patientOpdIpdNumber: values?.patientOpdIpdNumber,
          totalAmount: totalAmount,
        },
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        surgeryTreatmentStartDate: values?.surgeryTreatmentStartDate
          ? dayjs(values?.surgeryTreatmentStartDate).format(
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        admissionDate: values?.admissionDate
          ? dayjs(values?.admissionDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        diagnosisData,
      };

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: preAuth?.portalData?.casePreAuthCghs
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthCghs?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: updatedValues,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          totalAmount: totalAmount,
          action: "save",
        };
        setIsSubmitting(true);
        const resp = await saveDraftCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          payload,
        );
        successMessage("PreAuth Saved Successfully");
        setConfirmationModal(false);
        setIsSubmitting(false);
        if (resp) {
          dispatch(
            getPortalDataCghsNew({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
          fetchDocuments();
          await getTimelineDetail();
          await fetchStepperForStatus();
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, Fill details before submitting");
      } else {
        console.error(err);
        errorMessage("Please, Try again later");
      }
      setIsSubmitting(false);
    }
  };

  const handleUpdateAsDraft = async () => {
    try {
      // const values = await form.validateFields();
      const values = await form.getFieldsValue(true);
      const totalAmount = await form.getFieldsValue(true)?.totalIntimatedAmount;

      const documentData = documentUrls?.reduce((acc: any, list: any) => {
        switch (list?.documentLabelType) {
          case "CGHS CARD":
            acc.linkCghsCard = list?.documentUrl;
            acc.linkCghsCardDocId = list?.id;
            break;
          case "CAPF CARD":
            acc.linkCghsCard = list?.documentUrl;
            acc.linkCghsCardDocId = list?.id;
            break;
          case "REFERRAL LETTER":
            acc.linkReferralSlip = list?.documentUrl;
            acc.linkReferralSlipDocId = list?.id;
            break;
          case "CONSENT FORM":
            acc.linkProcedureConsentFile = list?.documentUrl;
            acc.linkProcedureConsentFileDocId = list?.id;
            break;
          case "EMERGENCY LETTER":
            acc.linkEmergencyLetterFile = list?.documentUrl;
            acc.linkEmergencyLetterFileDocId = list?.id;
            break;
          case "Justification for unspecified package":
            acc.linkJustificationLetterFile = list?.documentUrl;
            acc.linkJustificationLetterFileDocId = list?.id;
            break;
          case "OTHERS":
          default:
            acc.linkOtherDocument = list?.documentUrl;
            acc.linkOtherDocumentDocId = list?.id;
            break;
        }
        return acc;
      }, {});

      const updatedItems =
        values?.items
          ?.map((item: any, index: number) => {
            let parsedProcedureCode: any = {};

            if (typeof item?.procedureCode === "string") {
              try {
                parsedProcedureCode = JSON.parse(item.procedureCode);
              } catch {
                return null;
              }
            }

            if (!parsedProcedureCode?.procedureName) {
              return null;
            }
            return {
              ...item,
              casePreAuthCghsProceduresId: null,
              procedureId: parsedProcedureCode?.id,
              accreditationStatus: item?.accreditationStatus
                ? item?.accreditationStatus?.split("~")?.[0]
                : null,
              accreditationStatusName: item?.accreditationStatus
                ? item?.accreditationStatus?.split("~")?.[1]
                : null,
              treatingDoctorCode: item?.treatingDoctor
                ? item?.treatingDoctor?.split("~")?.[0]
                : null,
              treatingDoctorName: item?.treatingDoctor
                ? item?.treatingDoctor?.split("~")?.[1]
                : null,
              procedureReferral: item?.procedureReferral
                ? item?.procedureReferral?.split("~")?.[0]
                : null,
              procedureReferralName: item?.procedureReferral
                ? item?.procedureReferral?.split("~")?.[1]
                : null,
              stratsId: parsedProcedureCode?.id,
              treatmentStartDate: item?.treatmentStartDate
                ? dayjs(item?.treatmentStartDate).format("DD-MM-YYYY HH:mm:ss")
                : null,
              ...parsedProcedureCode,
              id: item?.casePreAuthCghsProceduresId || item?.pid || null,
            };
          })
          ?.filter(Boolean) || [];
      const updatedValues = {
        ...values,
        primaryDiagnosisCode: values?.primaryDiagnosis
          ? values?.primaryDiagnosis?.split("~")?.[0]
          : null,
        primaryDiagnosisName: values?.primaryDiagnosis
          ? values?.primaryDiagnosis?.split("~")?.[1]
          : null,
        doctorCode: values?.doctor ? values?.doctor?.split("~")?.[0] : null,
        // doctorName: values?.doctor ? values?.doctor?.split("~")?.[1] : null,
        govtHospitalCode: values?.govtHospital
          ? values?.govtHospital?.split("~")?.[0]
          : null,
        govtHospitalName: values?.govtHospital
          ? values?.govtHospital?.split("~")?.[1]
          : null,
        consultationType: values?.consultationType
          ? values?.consultationType?.split("~")?.[0]
          : null,
        consultationTypeName: values?.consultationType
          ? values?.consultationType?.split("~")?.[1]
          : null,
        visitType: values?.visitType
          ? values?.visitType?.split("~")?.[0]
          : null,
        visitTypeName: values?.visitType
          ? values?.visitType?.split("~")?.[1]
          : null,
        proposedDate: values?.proposedDate
          ? dayjs(values?.proposedDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        referralDate: values?.referralDate
          ? dayjs(values?.referralDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        totalIntimatedAmount: totalAmount,
        casePreAuthCghsProceduresList: updatedItems,
        listofResponseUrl: documentUrls,
        ...documentData,
        casePreAuthRequest: {
          beneficiaryId: values?.beneficiaryId,
          patientOpdIpdNumber: values?.patientOpdIpdNumber,
          totalAmount: totalAmount,
        },
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        surgeryTreatmentStartDate: values?.surgeryTreatmentStartDate
          ? dayjs(values?.surgeryTreatmentStartDate).format(
              "DD-MM-YYYY HH:mm:ss",
            )
          : null,
        admissionDate: values?.admissionDate
          ? dayjs(values?.admissionDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        diagnosisData,
      };

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: preAuth?.portalData?.casePreAuthCghs
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthCghs?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: updatedValues,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          totalAmount: totalAmount,
          action: "save",
        };

        setIsSubmitting(true);
        const resp = await updateDraftCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          preAuth.portalData?.id,
          payload,
        );
        successMessage("PreAuth Updated Successfully");
        setConfirmationModal(false);
        setIsSubmitting(false);
        if (resp) {
          dispatch(
            getPortalDataCghsNew({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
          fetchDocuments();
          await getTimelineDetail();
          await fetchStepperForStatus();
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, Fill details before submitting");
      } else {
        console.error(err);
        errorMessage("Please, Try again later");
      }
      setIsSubmitting(false);
    }
  };

  const handleDeleteDoctorDetails = async () => {
    try {
      // const values = await form.validateFields();

      const formData = {
        doctorName: null,
        doctorRegistrationId: null,
        doctorQualification: null,
        doctorContact: null,
      };

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: preAuth?.portalData?.casePreAuthCghs
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthCghs?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: formData,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
        };

        const resp = await deleteDoctorNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          preAuth.portalData?.id,
          payload,
        );
      }
    } catch (err: any) {
      console.error(err);
      errorMessage("Please, Try again later");
    }
  };

  const handleIntimateCghs = async () => {
    try {
      const actionType = "intimate";
      // const values = await form.validateFields();
      const values = await form.getFieldsValue(true);
      if (validateForm()) {
        const totalAmount =
          await form.getFieldsValue(true)?.totalIntimatedAmount;

        const documentData = documentUrls?.reduce((acc: any, list: any) => {
          switch (list?.documentLabelType) {
            case "CGHS CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "CAPF CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "REFERRAL LETTER":
              acc.linkReferralSlip = list?.documentUrl;
              acc.linkReferralSlipDocId = list?.id;
              break;
            case "CONSENT FORM":
              acc.linkProcedureConsentFile = list?.documentUrl;
              acc.linkProcedureConsentFileDocId = list?.id;
              break;
            case "EMERGENCY LETTER":
              acc.linkEmergencyLetterFile = list?.documentUrl;
              acc.linkEmergencyLetterFileDocId = list?.id;
              break;
            case "Justification for unspecified package":
              acc.linkJustificationLetterFile = list?.documentUrl;
              acc.linkJustificationLetterFileDocId = list?.id;
              break;
            case "OTHERS":
            default:
              acc.linkOtherDocument = list?.documentUrl;
              acc.linkOtherDocumentDocId = list?.id;
              break;
          }
          return acc;
        }, {});

        const updatedItems =
          values?.items
            ?.map((item: any, index: number) => {
              let parsedProcedureCode: any = {};

              if (typeof item?.procedureCode === "string") {
                try {
                  parsedProcedureCode = JSON.parse(item.procedureCode);
                } catch {
                  return null;
                }
              }

              if (!parsedProcedureCode?.procedureName) {
                return null;
              }
              return {
                ...item,
                casePreAuthCghsProceduresId: null,
                procedureId: parsedProcedureCode?.id,
                accreditationStatus: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[0]
                  : null,
                accreditationStatusName: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[1]
                  : null,
                treatingDoctorCode: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[0]
                  : null,
                treatingDoctorName: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[1]
                  : null,
                procedureReferral: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[0]
                  : null,
                procedureReferralName: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[1]
                  : null,
                stratsId: parsedProcedureCode?.id,
                treatmentStartDate: item?.treatmentStartDate
                  ? dayjs(item?.treatmentStartDate).format(
                      "DD-MM-YYYY HH:mm:ss",
                    )
                  : null,
                ...parsedProcedureCode,
                id: item?.casePreAuthCghsProceduresId || item?.pid || null,
              };
            })
            ?.filter(Boolean) || [];
        const updatedValues = {
          ...values,
          primaryDiagnosisCode: values?.primaryDiagnosis
            ? values?.primaryDiagnosis?.split("~")?.[0]
            : null,
          primaryDiagnosisName: values?.primaryDiagnosis
            ? values?.primaryDiagnosis?.split("~")?.[1]
            : null,
          doctorCode: values?.doctor ? values?.doctor?.split("~")?.[0] : null,
          // doctorName: values?.doctor ? values?.doctor?.split("~")?.[1] : null,
          govtHospitalCode: values?.govtHospital
            ? values?.govtHospital?.split("~")?.[0]
            : null,
          govtHospitalName: values?.govtHospital
            ? values?.govtHospital?.split("~")?.[1]
            : null,
          consultationType: values?.consultationType
            ? values?.consultationType?.split("~")?.[0]
            : null,
          consultationTypeName: values?.consultationType
            ? values?.consultationType?.split("~")?.[1]
            : null,
          visitType: values?.visitType
            ? values?.visitType?.split("~")?.[0]
            : null,
          visitTypeName: values?.visitType
            ? values?.visitType?.split("~")?.[1]
            : null,
          proposedDate: values?.proposedDate
            ? dayjs(values?.proposedDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          referralDate: values?.referralDate
            ? dayjs(values?.referralDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          totalIntimatedAmount: totalAmount,
          casePreAuthCghsProceduresList: updatedItems,
          listofResponseUrl: documentUrls,
          ...documentData,
          casePreAuthRequest: {
            beneficiaryId: values?.beneficiaryId,
            patientOpdIpdNumber: values?.patientOpdIpdNumber,
            totalAmount: totalAmount,
          },
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          action: actionType,
          surgeryTreatmentStartDate: values?.surgeryTreatmentStartDate
            ? dayjs(values?.surgeryTreatmentStartDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          admissionDate: values?.admissionDate
            ? dayjs(values?.admissionDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          diagnosisData,
        };

        if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          const payload = {
            schemeMetaDataId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
            portalMetaDataId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
            casePreAuthId: preAuth?.portalData?.casePreAuthCghs
              ?.casePreAuthResponse?.id
              ? preAuth?.portalData?.casePreAuthCghs?.id
              : 0,
            casePreAuthIhxRequest: null,
            casePreAuthCghsRequest: updatedValues,
            casePreAuthVidalRequest: null,
            casePreAuthStarhealthRequest: null,
            casePreAuthEchsRequest: null,
            totalAmount: totalAmount,
            action: actionType,
          };
          setIsSubmitting(true);
          const resp = await saveDraftCghsNew(
            patients?.fetchBasicDetails?.casesResponse?.id,
            patients?.fetchBasicDetails?.visitInfoResponse?.id,
            payload,
          );
          successMessage("PreAuth Sent To QC Successfully");
          setConfirmationModal(false);
          setIsSubmitting(false);
          if (resp) {
            dispatch(
              getPortalDataCghsNew({
                caseId: patients?.fetchBasicDetails?.casesResponse?.id,
                visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              }),
            );
            fetchDocuments();
            await getTimelineDetail();
            await fetchStepperForStatus();
            dispatch(
              getBasicDetails({
                id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              }),
            );
          }
        }
      } else {
        errorMessage("Please, Upload All Required Documents");
        setConfirmationModal(false);
        setIsSubmitting(false);
        setIsManuallyEnteredId(false);
        return;
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, Fill details before submitting");
      } else {
        console.error(err);
        errorMessage("Please, Try again later");
      }
      setIsSubmitting(false);
    }
  };

  const getStarmarkOptions = () => {
    let starmarkOptions: any = [...documentTypes]; // Create a copy of all possible options

    const isReferralNotMandatory = () => {
      const patientAge = patients?.fetchBasicDetails?.patientResponse?.age;
      if (patientAge) {
        return patientAge >= 70;
      }
    };

    const isConsentFormMandatory = () => {
      const patientAge = patients?.fetchBasicDetails?.patientResponse?.age;
      if (patientAge) {
        return (
          patientAge >= 70 &&
          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
            "OP"
        );
      }
    };

    const isEmergency =
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
      "EMERGENCY";

    const isReferralRequired = !isEmergency && !isReferralNotMandatory();

    const isRequired = (docValue: any) =>
      starmarkOptions.some(
        (doc: any) => doc?.label?.toUpperCase() === docValue && doc.required,
      );

    // Apply procedureConsent condition
    if (
      form.getFieldValue("procedureConsent") === "true" ||
      isConsentFormMandatory()
    ) {
      starmarkOptions = starmarkOptions?.filter(
        (doc: any) =>
          doc?.label?.toUpperCase() !== "OTHERS" &&
          doc?.label?.toUpperCase() !== "EMERGENCY LETTER" &&
          doc?.label?.toUpperCase() !==
            "Justification for unspecified package"?.toUpperCase(),
      );

      const procedureConsentDoc = documentTypes?.find(
        (doc: any) => doc?.label?.toUpperCase() === "CONSENT FORM",
      );
      if (procedureConsentDoc && !isRequired("CONSENT FORM")) {
        starmarkOptions.push({ ...procedureConsentDoc, required: true });
      }
    } else {
      starmarkOptions = starmarkOptions.filter(
        (doc: any) =>
          doc?.label?.toUpperCase() !== "OTHERS" &&
          doc?.label?.toUpperCase() !== "CONSENT FORM" &&
          doc?.label?.toUpperCase() !== "EMERGENCY LETTER" &&
          doc?.label?.toUpperCase() !==
            "Justification for unspecified package"?.toUpperCase(),
      );
    }

    // Apply Emergency visit type condition
    if (
      patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
      "EMERGENCY"
    ) {
      starmarkOptions = starmarkOptions?.filter(
        (doc: any) =>
          (doc?.label?.toUpperCase() !== "OTHERS" &&
            doc?.label?.toUpperCase() !== "REFERRAL LETTER" &&
            doc?.label?.toUpperCase() !==
              "Justification for unspecified package"?.toUpperCase()) ||
          isRequired(doc?.label?.toUpperCase()),
      );

      const emergencyLetterDoc = documentTypes?.find(
        (doc: any) => doc.label?.toUpperCase() === "EMERGENCY LETTER",
      );
      if (emergencyLetterDoc && !isRequired("EMERGENCY LETTER")) {
        starmarkOptions.push({ ...emergencyLetterDoc, required: true });
      }
    }

    // Apply unspecified procedures condition
    if (
      form
        .getFieldValue("items")
        ?.some((procedure: any) =>
          procedure?.specialityType?.toLowerCase()?.includes("s"),
        )
    ) {
      starmarkOptions = starmarkOptions?.filter(
        (doc: any) =>
          (doc?.label?.toUpperCase() !== "OTHERS" &&
            doc?.label?.toUpperCase() !== "REFERRAL LETTER" &&
            doc?.label?.toUpperCase() !== "EMERGENCY LETTER") ||
          isRequired(doc?.label?.toUpperCase()),
      );

      if (form.getFieldValue("procedureConsent")) {
        const procedureConsentDoc = documentTypes?.find(
          (doc: any) => doc?.label?.toUpperCase() === "CONSENT FORM",
        );
        if (procedureConsentDoc && !isRequired("CONSENT FORM")) {
          starmarkOptions.push({ ...procedureConsentDoc, required: true });
        }
      }

      const justificationLetterDoc = documentTypes?.find(
        (doc: any) =>
          doc?.label?.toUpperCase() ===
          "Justification for unspecified package"?.toUpperCase(),
      );
      if (
        justificationLetterDoc &&
        !isRequired("Justification for unspecified package"?.toUpperCase())
      ) {
        starmarkOptions.push({ ...justificationLetterDoc, required: true });
      }
    }

    const referralLetterDoc = documentTypes?.find(
      (doc: any) => doc?.label?.toUpperCase() === "REFERRAL LETTER",
    );
    if (!isReferralRequired && referralLetterDoc) {
      starmarkOptions = starmarkOptions.map((doc: any) =>
        doc?.label?.toUpperCase() === "REFERRAL LETTER"
          ? { ...doc, required: false }
          : doc,
      );
    } else if (isReferralRequired && referralLetterDoc) {
      starmarkOptions.push({ ...referralLetterDoc, required: true });
    }

    return starmarkOptions;
  };

  const handleFileChange =
    (documentType: string, isMultiple: boolean) => (e: any) => {
      if (rejectJfifUpload(e)) return;
      const maxFileSize = 1 * 1024 * 1024;
      // if (e?.file?.size > maxFileSize) {
      //   errorMessage("File Limit must be less than or equal to 1 MB");
      //   return;
      // }
      if (isMultiple) {
        const files = e?.fileList || [];
        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType,
          isMultiple: isMultiple,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        if (e?.file) {
          setSelectedFile({ file: e.file, documentType: documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setPreviewModalVisible(true);
        }
        return e?.target?.files;
      }
    };

  // const handleFileChange = (documentType: string) => (e: any) => {
  //   const maxSize = 15 * 1024 * 1024;

  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   if (e?.file) {
  //     setSelectedFile({ file: e.file, documentType: documentType });
  //     setPreviewFile({
  //       url: URL.createObjectURL(e.file),
  //       name: e.file.name,
  //       showUpload: true,
  //       documentType: documentType,
  //     });
  //     setPreviewModalVisible(true);
  //   }
  //   return e?.target?.files;
  // };

  const fetchStepperForStatus = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPreAuthTabActive()) {
      // fetchStepperForStatus();
      // getTimelineDetail();
    }
  }, [
    preAuth?.portalData,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    let timeoutId: NodeJS.Timeout | null = null;
    let pollCount = 0;
    const maxPolls = 24;
    const modifiedAt = preAuth?.portalData?.modifiedAt;

    const modifiedTime = new Date(modifiedAt).getTime();
    const now = Date.now();
    const diffSeconds = (now - modifiedTime) / 1000;

    if (
      preAuth?.portalData?.stateName === "Initiated" &&
      preAuth?.portalData?.visitStagesName?.toLowerCase() === "preauth" &&
      !preAuth?.portalData?.casePreAuthCghs?.claimId &&
      diffSeconds <= 78
    ) {
      intervalId = setInterval(() => {
        pollCount++;
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          dispatch(
            getPortalDataCghsNew({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }

        if (preAuth?.portalData?.casePreAuthCghs?.claimId) {
          if (intervalId) clearInterval(intervalId);
          if (timeoutId) clearTimeout(timeoutId);
        }

        if (pollCount >= maxPolls) {
          if (intervalId) clearInterval(intervalId);
          // setShowManualClaimIdModal(true);
        }
      }, 5000);

      timeoutId = setTimeout(() => {
        if (intervalId) clearInterval(intervalId);
        // setShowManualClaimIdModal(true);
      }, 120000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [
    preAuth?.portalData?.stateName,
    preAuth?.portalData?.visitStagesName,
    preAuth?.portalData?.casePreAuthCghs?.claimId,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  // useEffect(() => {
  //   if (
  //     preAuth?.portalData?.stateName === "Initiated" &&
  //     preAuth?.portalData?.visitStagesName?.toLowerCase() === "preauth" &&
  //     !preAuth?.portalData?.casePreAuthCghs?.claimId
  //   ) {
  //     setTimeout(() => {
  //       if (
  //         patients?.fetchBasicDetails?.casesResponse?.id &&
  //         patients?.fetchBasicDetails?.visitInfoResponse?.id
  //       ) {
  //         dispatch(
  //           getPortalDataCghsNew({
  //             caseId: patients?.fetchBasicDetails?.casesResponse?.id,
  //             visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //           })
  //         );
  //       }
  //     }, 5000);

  //     if (!preAuth?.portalData?.casePreAuthCghs?.claimId) {
  //       setTimeout(() => {
  //         if (
  //           patients?.fetchBasicDetails?.casesResponse?.id &&
  //           patients?.fetchBasicDetails?.visitInfoResponse?.id
  //         ) {
  //           dispatch(
  //             getPortalDataCghsNew({
  //               caseId: patients?.fetchBasicDetails?.casesResponse?.id,
  //               visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //             })
  //           );
  //         }
  //       }, 60000);
  //     }
  //   }
  // }, [preAuth?.portalData]);

  const [isApproved, setIsApproved] = useState(false);
  const [isApprovedInitiated, setIsApprovedInitiated] = useState(false);

  useEffect(() => {
    setIsApproved(
      preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.approved,
    );
  }, [preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.approved]);

  const handleApprovePreAuth = async () => {
    try {
      await form.validateFields();
      // if (diagnosisData?.length === 0) {
      //   errorMessage("Please, Fill Diagnosis data");
      //   setSubmissionModal(false);
      //   setIsSubmittedOnPortal(false);
      //   setIsSubmitting(false);
      //   return;
      // }
      const values = await form.getFieldsValue(true);
      if (validateForm()) {
        const totalAmount =
          await form.getFieldsValue(true)?.totalIntimatedAmount;

        const documentData = documentUrls?.reduce((acc: any, list: any) => {
          switch (list?.documentLabelType) {
            case "CGHS CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "CAPF CARD":
              acc.linkCghsCard = list?.documentUrl;
              acc.linkCghsCardDocId = list?.id;
              break;
            case "REFERRAL LETTER":
              acc.linkReferralSlip = list?.documentUrl;
              acc.linkReferralSlipDocId = list?.id;
              break;
            case "CONSENT FORM":
              acc.linkProcedureConsentFile = list?.documentUrl;
              acc.linkProcedureConsentFileDocId = list?.id;
              break;
            case "EMERGENCY LETTER":
              acc.linkEmergencyLetterFile = list?.documentUrl;
              acc.linkEmergencyLetterFileDocId = list?.id;
              break;
            case "Justification for unspecified package":
              acc.linkJustificationLetterFile = list?.documentUrl;
              acc.linkJustificationLetterFileDocId = list?.id;
              break;
            case "OTHERS":
            default:
              acc.linkOtherDocument = list?.documentUrl;
              acc.linkOtherDocumentDocId = list?.id;
              break;
          }
          return acc;
        }, {});

        const updatedItems =
          values?.items
            ?.map((item: any, index: number) => {
              let parsedProcedureCode: any = {};

              if (typeof item?.procedureCode === "string") {
                try {
                  parsedProcedureCode = JSON.parse(item.procedureCode);
                } catch {
                  return null;
                }
              }

              if (!parsedProcedureCode?.procedureName) {
                return null;
              }

              return {
                ...item,
                casePreAuthCghsProceduresId: null,
                procedureId: parsedProcedureCode?.id,
                accreditationStatus: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[0]
                  : null,
                accreditationStatusName: item?.accreditationStatus
                  ? item?.accreditationStatus?.split("~")?.[1]
                  : null,
                treatingDoctorCode: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[0]
                  : null,
                treatingDoctorName: item?.treatingDoctor
                  ? item?.treatingDoctor?.split("~")?.[1]
                  : null,
                procedureReferral: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[0]
                  : null,
                procedureReferralName: item?.procedureReferral
                  ? item?.procedureReferral?.split("~")?.[1]
                  : null,
                stratsId: parsedProcedureCode?.id,
                treatmentStartDate: item?.treatmentStartDate
                  ? dayjs(item?.treatmentStartDate).format(
                      "DD-MM-YYYY HH:mm:ss",
                    )
                  : null,
                ...parsedProcedureCode,
                id: item?.casePreAuthCghsProceduresId || item?.pid || null,
              };
            })
            ?.filter(Boolean) || [];
        const updatedValues = {
          ...values,
          primaryDiagnosisCode: values?.primaryDiagnosis
            ? values?.primaryDiagnosis?.split("~")?.[0]
            : null,
          primaryDiagnosisName: values?.primaryDiagnosis
            ? values?.primaryDiagnosis?.split("~")?.[1]
            : null,
          doctorCode: values?.doctor ? values?.doctor?.split("~")?.[0] : null,
          // doctorName: values?.doctor ? values?.doctor?.split("~")?.[1] : null,
          govtHospitalCode: values?.govtHospital
            ? values?.govtHospital?.split("~")?.[0]
            : null,
          govtHospitalName: values?.govtHospital
            ? values?.govtHospital?.split("~")?.[1]
            : null,
          consultationType: values?.consultationType
            ? values?.consultationType?.split("~")?.[0]
            : null,
          consultationTypeName: values?.consultationType
            ? values?.consultationType?.split("~")?.[1]
            : null,
          visitType: values?.visitType
            ? values?.visitType?.split("~")?.[0]
            : null,
          visitTypeName: values?.visitType
            ? values?.visitType?.split("~")?.[1]
            : null,
          totalIntimatedAmount: totalAmount,
          proposedDate: values?.proposedDate
            ? dayjs(values?.proposedDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          referralDate: values?.referralDate
            ? dayjs(values?.referralDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          casePreAuthCghsProceduresList: updatedItems,
          listofResponseUrl: documentUrls,
          ...documentData,
          casePreAuthRequest: {
            beneficiaryId: values?.beneficiaryId,
            patientOpdIpdNumber: values?.patientOpdIpdNumber,
            totalAmount: totalAmount,
          },
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          surgeryTreatmentStartDate: values?.surgeryTreatmentStartDate
            ? dayjs(values?.surgeryTreatmentStartDate).format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : null,
          admissionDate: values?.admissionDate
            ? dayjs(values?.admissionDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          diagnosisData,
        };

        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: preAuth?.portalData?.casePreAuthCghs
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: updatedValues,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          totalAmount: totalAmount,
        };

        setIsApprovedInitiated(true);
        const formData = {
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          stage: "PreAuth",
          approved: true,
          preAuthRequest: payload,
          casePreAuthId: preAuth?.portalData?.casePreAuthCghs
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.id
            : 0,
        };
        const res = await submitApprovalCghsNew(formData);
        setIsApproved(true);
        setIsApprovedInitiated(false);
        message.success("PreAuth Approved Successfully");
        setConfirmationModal(false);
        await getTimelineDetail();
        await fetchStepperForStatus();
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          dispatch(
            getPortalDataCghsNew({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
        await fetchDocuments();
        if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            }),
          );
        }
      } else {
        errorMessage("Please, Upload All Required Documents");
        setSubmissionModal(false);
        setIsSubmittedOnPortal(false);
        setIsSubmitting(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, Fill details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
      setIsApprovedInitiated(false);
      setIsApproved(false);
    }
  };

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [confirmationState, setConfirmationState] = useState<string>("");

  const handleSaveConfirmationModal = async (confirmationState: string) => {
    if (confirmationState === "intimate") {
      if (auth?.role?.role !== "FO_STAFF") {
        try {
          await form.validateFields();
        } catch (err: any) {
          if (err?.errorFields) {
            errorMessage("Please, fill all details before submitting");
          } else {
            errorMessage("Please, Try again later");
          }
          return;
        }
      }
      if (!validateForm()) {
        errorMessage("Please, Upload All Required Documents");
        return;
      }
    }

    setConfirmationModal(true);
    setConfirmationState(confirmationState);

    if (confirmationState === "save") {
      setTitle("Do You want to save PreAuth ?");
    } else if (confirmationState === "update") {
      setTitle("Do You want to update PreAuth ?");
    } else if (confirmationState === "intimate") {
      setTitle("Do you want to send PreAuth for QC ?");
    } else if (confirmationState === "submit") {
      setTitle("Do You want to submit PreAuth ?");
    } else if (confirmationState === "approve") {
      setTitle("Do You want to approve PreAuth ?");
    }
  };

  const handleSave = async () => {
    if (confirmationState === "save") {
      await handleSaveAsDraft();
    } else if (confirmationState === "update") {
      await handleUpdateAsDraft();
    } else if (confirmationState === "intimate") {
      await handleIntimateCghs();
    } else if (confirmationState === "approve") {
      await handleApprovePreAuth();
    } else if (confirmationState === "submit") {
      await handleSaveManually();
    }

    setConfirmationModal(false);
  };

  const [billItemsList, setBillItemsList] = useState<any[]>([]);
  const [govtBillMappingId, setGovtBillMappingId] = useState<number | null>(
    null,
  );

  const fetchHospitalBillList = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        const filters = {
          pageNumber: 1,
          pageSize: 10,
          searchTer: "",
        };
        const response = await getGovtBillList(
          patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          filters,
        );

        setGovtBillMappingId(
          response?.data?.billMappingResponseList?.length
            ? response.data.billMappingResponseList?.[0].id
            : null,
        );
      }
    } catch (err) {}
  };

  const itemsProcedure = Form.useWatch("items", form);

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPreAuthTabActive()) {
      fetchHospitalBillList();
    }
  }, [activeKey, patients?.fetchBasicDetails?.casesResponse?.healthCareId]);

  // useEffect(() => {
  //   if (
  //     (!preAuth?.portalData?.casePreAuthCghs?.casePreAuthCghsProceduresList ||
  //       preAuth?.portalData?.casePreAuthCghs?.casePreAuthCghsProceduresList
  //         ?.length === 0) &&
  //     activeKey &&
  //     activeKey?.length > 0 &&
  //     isPreAuthTabActive()
  //   ) {
  //     fetchGovtBill();
  //   }
  // }, [govtBillMappingId, activeKey, preAuth?.portalData]);

  useEffect(() => {
    const procedures =
      preAuth?.portalData?.casePreAuthCghs?.casePreAuthCghsProceduresList || [];

    const isEmpty = !procedures || procedures?.length === 0;

    const hasSingleWithoutProcedureName =
      procedures?.length === 1 && !procedures[0]?.procedureName;

    if (
      (isEmpty || hasSingleWithoutProcedureName) &&
      activeKey &&
      activeKey?.length > 0 &&
      isPreAuthTabActive()
    ) {
      fetchGovtBill();
    }
  }, [
    activeKey,
    preAuth?.portalData?.casePreAuthCghs?.casePreAuthCghsProceduresList,
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    govtBillMappingId,
  ]);

  const fetchGovtBill = async () => {
    try {
      if (
        !patients?.fetchBasicDetails?.casesResponse?.healthCareId ||
        !govtBillMappingId
      )
        return;
      setIsFetchingBillDetails(true);
      const response = await dispatch(
        GovtBillFetchRequest({
          healthCareId:
            patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          govtBillMappingId: govtBillMappingId,
        }),
      );
      setIsFetchingBillDetails(false);
      setBillItemsList(response?.payload?.data?.billItemsResponseList || []);
      if (!form.getFieldValue("billDate")) {
        form.setFieldsValue({
          billDate: response?.payload?.data?.billHeaderResponse?.billDateTime
            ? dayjs(
                response?.payload?.data?.billHeaderResponse?.billDateTime,
                "DD/MM/YYYY",
              )
            : null,
        });
      }

      if (
        !form.getFieldValue("admissionDate") ||
        !preAuth?.portalData?.casePreAuthCghs?.admissionDate
      ) {
        form.setFieldsValue({
          admissionDate: response?.payload?.data?.billHeaderResponse
            ?.billDateTime
            ? dayjs(
                response?.payload?.data?.billHeaderResponse?.billDateTime,
                "DD/MM/YYYY",
              )
            : null,
        });
      }

      if (
        !form.getFieldValue("surgeryTreatmentStartDate") ||
        !preAuth?.portalData?.casePreAuthCghs?.surgeryTreatmentStartDate
      ) {
        form.setFieldsValue({
          surgeryTreatmentStartDate: response?.payload?.data?.billHeaderResponse
            ?.billDateTime
            ? dayjs(
                response?.payload?.data?.billHeaderResponse?.billDateTime,
                "DD/MM/YYYY",
              )
            : null,
        });
      }

      if (!form.getFieldValue("billNumber")) {
        form.setFieldsValue({
          billNumber: response?.payload?.data?.billHeaderResponse?.billNo
            ? response?.payload?.data?.billHeaderResponse?.billNo
            : null,
        });
      }
    } catch (error) {
      console.error("Error in fetching bill:", error);
    } finally {
      setIsFetchingBillDetails(false);
    }
  };

  const [mappedProcedures, setMappedProcedures] = useState<any[]>([]);

  useEffect(() => {
    if (
      billItemsList &&
      billItemsList?.length > 0 &&
      preAuthClaim?.procedureDropDown &&
      preAuthClaim?.procedureDropDown?.length > 0
    ) {
      const autoMappedProcedures = mapBillItemsWithProcedures(
        billItemsList || [],
        preAuthClaim?.procedureDropDown || [],
      );

      setMappedProcedures(autoMappedProcedures);
    }
  }, [billItemsList, preAuthClaim?.procedureDropDown]);

  useEffect(() => {
    if (!mappedProcedures?.length) return;
    const items = mappedProcedures?.map((item: any) => ({
      numberOfDays: item?.numberOfDays ?? null,
      externalProcedureCode: item?.externalProcedureCode ?? null,
      strats: item?.strats ?? null,
      // admissibleRate: item?.admissibleRate ?? null,
      procedureAmount: item?.procedureAmount ?? null,
      totalIntimatedAmount:
        item?.procedureAmount && item?.numberOfDays
          ? parseFloat(item?.procedureAmount) * parseFloat(item?.numberOfDays)
          : null,
      // hospitalRemark: item?.hospitalRemark ?? null,
      treatmentStartDate: patients?.fetchBasicDetails?.visitInfoResponse?.doa
        ? dayjs(
            patients?.fetchBasicDetails?.visitInfoResponse?.doa,
            "DD-MM-YYYY HH:mm:ss",
          )
        : null,
      accreditationStatus:
        // !patients?.fetchBasicDetails?.casesResponse?.healthCareName
        //   ?.toLowerCase()
        //   ?.includes("saroj gupta")
        //   ? "NABL~NABL"
        //   : "NON NABL~NON NABL",
        patients?.fetchBasicDetails?.casesResponse?.nablStatus
          ? "NABL~NABL"
          : patients?.fetchBasicDetails?.casesResponse?.nabhStatus
            ? "NABH~NABH"
            : "NON NABH~NON NABH",
      treatingDoctor: "OTHERS~OTHERS",
      procedureReferral: "referral~REFERRAL",
      id: null,
      referralServiceName: item?.referralServiceName ?? null,
      pid: item?.pid,
      stratsId: item?.stratsId,
      procedureCode: item?.procedureName
        ? JSON.stringify({
            procedureCode: item?.procedureCode,
            procedureName: item?.procedureName,
            procedureType: item?.procedureType,
            externalProcedureCode: item?.externalProcedureCode,
            strats: item?.strats,
            id: Number(item?.id) || Number(item?.stratsId) || null,
            nablStatus: item?.nablStatus || null,
            specialityType: item?.specialityType || null,
          })
        : null,
    }));
    const isEmpty = !itemsProcedure || itemsProcedure?.length === 0;

    const hasSingleWithoutProcedureName =
      itemsProcedure?.length === 1 && !itemsProcedure[0]?.procedureName;

    if (
      isEmpty ||
      hasSingleWithoutProcedureName ||
      itemsProcedure?.length > 0
    ) {
      form.setFieldsValue({ items: items?.length > 0 ? items : null });
    }
  }, [mappedProcedures]);

  function mapBillItemsWithProcedures(billItems: any, procedures: any) {
    if (!Array.isArray(billItems) || !Array.isArray(procedures)) {
      return [];
    }

    const groupedByCode = new Map();

    billItems
      ?.filter((item: any) => item.schemeCode && item.schemeCode.trim() !== "")
      ?.forEach((item: any) => {
        const matchedProcedure = procedures?.find(
          (proc: any) => proc.externalProcedureCode === item.schemeCode,
        );

        if (!matchedProcedure) return;

        const key = matchedProcedure?.externalProcedureCode || item.schemeCode;
        const serviceQty = Number(item.serviceQty || 0);
        const serviceRate = Number(item.serviceSchemeRate || 0);

        if (!groupedByCode.has(key)) {
          groupedByCode.set(key, {
            matchedProcedure,
            totalQty: 0,
            serviceRate,
            serviceName: item?.serviceName,
          });
        }

        const group = groupedByCode.get(key);
        group.totalQty += serviceQty;
        group.serviceRate = group.serviceRate || serviceRate;
      });

    const mappedProcedures: any[] = [];

    groupedByCode.forEach(
      ({ matchedProcedure, totalQty, serviceRate, serviceName }: any) => {
        const allowedQty = Number(
          matchedProcedure?.quantityAllowed ??
            matchedProcedure?.allowedQty ??
            matchedProcedure?.qtyAllowed ??
            0,
        );

        let remainingQty = totalQty;

        while (remainingQty > 0) {
          const chunkQty =
            allowedQty > 0 ? Math.min(remainingQty, allowedQty) : remainingQty;

          mappedProcedures.push({
            id: null,
            nablStatus: null,
            externalProcedureCode: matchedProcedure.externalProcedureCode,
            procedureCode: matchedProcedure.procedureCode,
            procedureName: matchedProcedure.procedureName,
            procedureType: matchedProcedure.procedureType ?? null,
            numberOfDays: String(chunkQty),
            procedureAmount: String(serviceRate),
            totalIntimatedAmount: String(chunkQty * serviceRate),
            referralServiceName: serviceName,
            strats: matchedProcedure?.strats,
            stratsId: matchedProcedure?.id,
            specialityType: matchedProcedure?.specialityType,
          });

          remainingQty = remainingQty - chunkQty;
        }
      },
    );

    return mappedProcedures;
  }

  // function mapBillItemsWithProcedures(billItems: any, procedures: any) {
  //   if (!Array.isArray(billItems) || !Array.isArray(procedures)) {
  //     return [];
  //   }

  //   return billItems
  //     ?.filter((item) => item.schemeCode && item.schemeCode.trim() !== "")
  //     ?.map((item) => {
  //       // 2. find matching procedure
  //       const matchedProcedure = procedures?.find(
  //         (proc) => proc.externalProcedureCode === item.schemeCode,
  //       );

  //       if (!matchedProcedure) return null;

  //       const serviceQty = Number(item.serviceQty || 0);
  //       const serviceRate = Number(item.serviceRate || 0);
  //       const schemeRate = Number(item.serviceSchemeRate || 0);

  //       return {
  //         id: null,
  //         nablStatus: matchedProcedure.nablStatus,
  //         externalProcedureCode: matchedProcedure.externalProcedureCode,
  //         procedureCode: matchedProcedure.procedureCode,
  //         procedureName: matchedProcedure.procedureName,
  //         procedureType: matchedProcedure.procedureType ?? null,
  //         numberOfDays: String(serviceQty),
  //         // admissibleRate: String(schemeRate),
  //         procedureAmount: String(serviceRate),
  //         totalIntimatedAmount: String(serviceQty * serviceRate),
  //         // hospitalRemark: matchedProcedure.hospitalRemark ?? null,
  //         referralServiceName: item?.serviceName,
  //         strats: matchedProcedure?.strats,
  //         stratsId: matchedProcedure?.id,
  //       };
  //     })
  //     ?.filter(Boolean);
  // }

  return (
    <>
      {false ? ( //preAuthClaim?.isFetchingProcedure
        <Loader />
      ) : (
        <PreAuthCghsNew
          patientStore={patients?.fetchBasicDetails}
          portalData={preAuth?.portalData}
          activeKey={activeKey}
          formattedAdmissionType={formattedAdmissionType}
          formattedPatientDiagnosed={formattedPatientDiagnosed}
          medcoDoctors={medcoDoctors}
          formattedAdmissionTypeOp={formattedAdmissionTypeOp}
          formattedConsultationType={formattedConsultationType}
          govtHospitalList={govtHospitalList}
          diagnosisList={diagnosisList}
          formattedAccreditationOptions={formattedAccreditationOptions}
          formattedTreatingDoctorsOptions={formattedTreatingDoctorsOptions}
          formattedProcedureReferral={formattedProcedureReferral}
          formattedProceduresOptions={formattedProceduresOptions}
          handleGetProcedureAmount={handleGetProcedureAmount}
          handleGetProcedureStrats={handleGetProcedureStrats}
          procedureStrats={procedureStrats}
          handleDeleteProcedure={handleDeleteProcedure}
          form={form}
          handleSubmit={handleSubmit}
          documentRequestResponseDocuments={documentRequestResponseDocuments}
          handleSaveAsDraft={handleSaveAsDraft}
          handleUpdateAsDraft={handleUpdateAsDraft}
          documentTypes={documentTypes}
          handleOpen={handleOpen}
          currentVisitStage={preAuth?.stepperData?.currentVisitStage}
          handleSaveData={handleSaveData}
          documentUrls={documentUrls}
          loading={loading}
          handleFileChange={handleFileChange}
          handleApprovePreAuth={handleApprovePreAuth}
          isApproved={isApproved}
          isApprovedInitiated={isApprovedInitiated}
          handleSaveConfirmationModal={handleSaveConfirmationModal}
          getStarmarkOptions={getStarmarkOptions}
          uploadFileList={uploadFileList}
          handleGetProcedureFromBill={handleImportProcedureFromBill}
          isFetchingBillAuditProcedure={isFetchingBillAuditProcedure}
          setDiagnosisData={setDiagnosisData}
          diagnosisData={diagnosisData}
          handleDeleteDoctorDetails={handleDeleteDoctorDetails}
          isFetchingBillDetails={isFetchingBillDetails}
          allDocumentList={allDocumentList}
        />
      )}

      {/* <UploadDocumentCghsPreAuth
        visible={isModalOpen}
        documentTypes={documentTypes}
        setDocumentTypes={setDocumentTypes}
        // onOk={handleModalOk}
        onCancel={handleModalClose}
        setDocumentUrls={setDocumentUrls}
        isLoading={enhancement?.isLoading}
        getStarmarkOptions={getStarmarkOptions}
      /> */}

      {selectedFile?.file && !selectedFiles?.length && (
        <FilePreviewModal
          isVisible={previewModalVisible}
          onClose={() => setPreviewModalVisible(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          documentType={previewFile.documentType}
          handleUpload={handleUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.lastModified || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      <PatientDetailsStageDocument
        // key={documentUrl}
        handleCancel={handleCancelPreview}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        claimId={
          preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
        }
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        clickedActiveTab={clickedActiveTab}
        isSubmittedStatus={
          preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
        }
        isIntimated={
          preAuth?.portalData?.casePreAuthCghs?.casePreAuthResponse?.intimated
        }
        fetchingDeficiencyData={fetchingDeficiencyData}
        selectedDocument={selectedDocument}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
      />

      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
      />

      {/* <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      /> */}

      <PortalSubmissionModal
        open={isSubmittedOnPortal}
        title={"Is PreAuth Already Submitted on Portal?"}
        handleCancel={handleCancelSubmissionPortal}
        handleSave={handleManuallyIdEnter}
      />

      <ManuallyIdModal
        open={isManuallyEnteredId}
        title={"Enter Claim Id"}
        handleCancel={handleCancelManuallyId}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading}
      />

      <PortalSubmitModal
        open={submissionModal}
        title={"Do You want to Register PreAuth?"}
        handleOk={handleOk}
        handleCancel={handleRegistrationCancel}
        handleSave={handleSaveModalOption}
        isLoading={isSubmitting}
      />

      <ProcedureConfirmationModal
        open={open}
        title={"Do you want to add these procedures?"}
        handleCancel={handleCancelPortal}
        handleSave={handleEnterClick}
      />

      <ConfirmSubmissionModalStage
        open={confirmationModal}
        title={title}
        handleCancel={() => setConfirmationModal(false)}
        handleSave={handleSave}
        isLoading={isApprovedInitiated || isSubmitting}
      />

      <ManuallyClaimIdPortal
        open={manuallyClaimIdPortal}
        title={"Enter Claim Id"}
        handleCancel={() => setManuallyClaimIdPortal(false)}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isSubmitting}
      />

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
            setUploadFileList([]);
          }}
          files={previewFiles}
          handleUpload={handleUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      <ConfirmationImportProcedureModal
        open={getProcedureFromBill}
        title={"Do you want to import Procedure from bill ?"}
        handleCancel={() => setGetProcedureFromBill(false)}
        handleSave={handleGetProcedureFromBill}
        isLoading={isFetchingBillAuditProcedure}
      />
    </>
  );
};

export default PreAuthCghsContainerNew;
